import * as React from "react";
import { useEffect, useState, useRef } from "react";
import { graphql, useStaticQuery } from "gatsby";

// force push

const DropDown = ({ data }) => {
  return (
    <div className="absolute z-10 right-0 top-full hidden group-hover:block">
      <div
        style={{
          padding: "16px 0px",
        }}
        className=" bg-[#fff] flex flex-col lg:rounded-2xl overflow-hidden lg:shadow-[rgba(0,0,0,0.25)_0px_15px_15px_0px]"
      >
        {data.map((link, index) => {
          return (
            <a
              className="!text-[#636672] hover:!text-[#000538] nav-dropdown w-max flex items-center primary-nav-child"
              style={{ padding: "5px 25px", fontSize: "14px" }}
              key={index + Math.random()}
              href={link.href}
            >
              {link?.icon && (
                <span
                  className="flex items-center"
                  style={{
                    width: "20px",
                    height: "20px",
                    marginRight: "10px",
                    overflow: "hidden",
                  }}
                >
                  {link?.icon}
                </span>
              )}
              <span>{link.title}</span>
            </a>
          );
        })}
      </div>
    </div>
  );
};

const MegaMenuB = ({ data = [] }) => {
  const [mobileActive, setMobileActive] = useState(-1);

  const BackButton = () => {
    return (
      <button
        onClick={() => {
          setMobileActive(-1);
        }}
        className="flex items-center gap-3 lg:hidden px-[16px] font-normal pt-[16px] pb-2"
      >
        <span>
          <svg
            width="10"
            height="14"
            viewBox="0 0 10 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.54324 1.645L3.92703 7L9.54324 12.355L7.81424 14L0.456757 7L7.81424 8.77371e-08L9.54324 1.645Z"
              fill="#0738F1"
            />
          </svg>
        </span>
        <span>Back</span>
      </button>
    );
  };

  // lg:max-w-[50%] lg:max-w-[35%] lg:max-w-[65%]
  // max-w-[50%] max-w-[35%] max-w-[65%]
  // w-[50%] w-[35%] w-[65%]

  return (
    <div
      className={`bg-[#fff] lg:absolute lg:left-[30px] lg:top-[85%] w-full max-w-full lg:max-w-[882px] lg:rounded-2xl lg:overflow-hidden lg:bg-[#EDF0FF] lg:shadow-[rgba(0,0,0,0.25)_0px_15px_15px_0px] lg:hidden lg:group-hover:flex`}
    >
      {data?.primaryLink && (
        <div className="lg:flex lg:flex-col lg:relative max-w-[260px] primary-nav-parent">
          <a href={data?.primaryLink?.link || ""}>
            <div className="border-[#BCC3E5] svg-hover py-1.5 lg:py-[28px] px-[16px] lg:px-[28px]">
              <p
                className=" lg:text-[16px] lg:font-bold flex items-center lg:pb-1"
                style={{ margin: 0 }}
              >
                <span>{data.primaryLink?.title || ""}</span>
                <span
                  className="transform translate-x-2 hidden lg:flex"
                  style={{ marginLeft: "-5px" }}
                >
                  <svg
                    width="12"
                    height="11"
                    viewBox="0 0 12 11"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M11.853 5.98808C11.853 5.98808 11.8648 5.96457 11.8707 5.95281C11.8942 5.91753 11.9177 5.87637 11.9294 5.83522C11.9353 5.81758 11.9412 5.79994 11.9471 5.7823C11.9588 5.74703 11.9706 5.71175 11.9824 5.67059C11.9941 5.6118 12 5.553 12 5.49421C12 5.43541 11.9941 5.37662 11.9824 5.31783C11.9765 5.28255 11.9588 5.24139 11.9471 5.20612C11.9412 5.18848 11.9353 5.17084 11.9294 5.1532C11.9118 5.11204 11.8883 5.07677 11.8707 5.03561C11.8648 5.02385 11.8589 5.01209 11.853 5.00033C11.8236 4.9533 11.7825 4.90626 11.7413 4.86511L7.89025 1.01993C7.54336 0.673043 6.98481 0.673043 6.6438 1.01993C6.30279 1.36682 6.29691 1.92537 6.6438 2.26638L7.26703 2.8896L8.99559 4.61817H0.881921C0.393925 4.61817 0 5.01209 0 5.50009C0 5.98808 0.393925 6.38201 0.881921 6.38201H8.99559L7.26703 8.11057L6.6438 8.7338C6.29691 9.08069 6.29691 9.63924 6.6438 9.98025C6.81431 10.1508 7.04361 10.2389 7.26703 10.2389C7.49045 10.2389 7.71975 10.1508 7.89025 9.98025L11.7472 6.12331C11.7883 6.08216 11.8236 6.03512 11.8589 5.98808H11.853Z"
                      fill="#000538"
                    />
                  </svg>
                </span>
              </p>
              <p
                className="text-[14px] text-[#8289A1] hidden lg:block"
                style={{ margin: "0", paddingBottom: "12px" }}
              >
                {data.primaryLink?.description || ""}
              </p>
              {/* <p
                className="font-bold items-center hidden lg:flex"
                style={{ margin: "0" }}
              >
                <span style={{ fontSize: "16px" }}>
                  {data.secondaryLink?.title || ""}
                </span>
                <span className="transform translate-x-2">
                  <svg
                    width="12"
                    height="11"
                    viewBox="0 0 12 11"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M11.853 5.98808C11.853 5.98808 11.8648 5.96457 11.8707 5.95281C11.8942 5.91753 11.9177 5.87637 11.9294 5.83522C11.9353 5.81758 11.9412 5.79994 11.9471 5.7823C11.9588 5.74703 11.9706 5.71175 11.9824 5.67059C11.9941 5.6118 12 5.553 12 5.49421C12 5.43541 11.9941 5.37662 11.9824 5.31783C11.9765 5.28255 11.9588 5.24139 11.9471 5.20612C11.9412 5.18848 11.9353 5.17084 11.9294 5.1532C11.9118 5.11204 11.8883 5.07677 11.8707 5.03561C11.8648 5.02385 11.8589 5.01209 11.853 5.00033C11.8236 4.9533 11.7825 4.90626 11.7413 4.86511L7.89025 1.01993C7.54336 0.673043 6.98481 0.673043 6.6438 1.01993C6.30279 1.36682 6.29691 1.92537 6.6438 2.26638L7.26703 2.8896L8.99559 4.61817H0.881921C0.393925 4.61817 0 5.01209 0 5.50009C0 5.98808 0.393925 6.38201 0.881921 6.38201H8.99559L7.26703 8.11057L6.6438 8.7338C6.29691 9.08069 6.29691 9.63924 6.6438 9.98025C6.81431 10.1508 7.04361 10.2389 7.26703 10.2389C7.49045 10.2389 7.71975 10.1508 7.89025 9.98025L11.7472 6.12331C11.7883 6.08216 11.8236 6.03512 11.8589 5.98808H11.853Z"
                      fill="#000538"
                    />
                  </svg>
                </span>
              </p> */}
            </div>
          </a>
        </div>
      )}
      <div className="bg-[#fff] flex-1 flex flex-col lg:flex-row lg:p-[28px]">
        <style>
          {`
          .col-items {
            padding-left: 16px;
            padding-right: 16px;
            padding-top: 16px;
            padding-bottom: 0px;
          }

          .col-items span:first-child {
            padding-bottom: 16px;
          }

          @media (min-width: 1024px) {
            .col-items {
              padding-left: 0px;
              padding-right: 0px;
              padding-top: 7.5px;
              padding-bottom: 7.5px;
            }

            .col-items span:first-child {
              padding-bottom: 0px;
            }
          }
        `}
        </style>
        {data?.col1 && (
          <div className={`w-full lg:max-w-[${data.col1.width}]`}>
            <button
              onClick={() => {
                setMobileActive(0);
              }}
              className="w-full flex items-center pointer-events-auto lg:pointer-events-none lg:uppercase lg:text-[12px] lg:text-[#00A3A3] font-bold pb-1.5 lg:pb-3 pt-1.5 lg:pt-0 px-[16px] lg:px-0 lg:tracking-[1.5px]"
              style={{ margin: "0" }}
            >
              {data.col1.title}
              <svg
                className="ml-auto block lg:hidden"
                width="10"
                height="14"
                viewBox="0 0 10 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.456758 12.355L6.07297 7L0.456757 1.645L2.18576 8.77371e-08L9.54324 7L2.18576 14L0.456758 12.355Z"
                  fill="#0738F1"
                />
              </svg>
            </button>
            <div
              style={{
                gridTemplateColumns: `repeat(${data.col1.colNum}, minmax(0, 1fr))`,
              }}
              className={`h-full lg:h-auto lg:grid top-[80px] lg:top-0 absolute lg:relative bg-[#fff] w-full transition-all transform lg:transform-none ${
                mobileActive === 0 ? "translate-x-[0%]" : "translate-x-[100%]"
              }`}
            >
              <BackButton />
              <p className="m-0 pt-[16px] uppercase text-[#0738F1] block lg:hidden tracking-[2px] px-[16px]">
                <span className="border-b pb-[16px] lg:pb-2 lg:pt-2 block w-full">
                  {data.col1.title}
                </span>
              </p>
              {data.col1.items.map((item, index) => {
                return (
                  <a
                    key={index + Math.random()}
                    style={{
                      color: "var(--lacework-text)",
                      fontWeight: "400",
                    }}
                    className="flex items-center text-[16px] lg:text-[14px] svg-hover col-items primary-nav-child"
                    href={item?.link || "/"}
                    target={item?.targetBlank ? "_blank" : "_self"}
                  >
                    <span className="border-b lg:border-b-0 w-full lg:w-auto">
                      {item.title}
                    </span>
                    {/* <span
                      className="transform translate-x-2"
                      style={{ marginLeft: "-5px" }}
                    >
                      <svg
                        className="hidden lg:block"
                        width="12"
                        height="11"
                        viewBox="0 0 12 11"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M11.853 5.98808C11.853 5.98808 11.8648 5.96457 11.8707 5.95281C11.8942 5.91753 11.9177 5.87637 11.9294 5.83522C11.9353 5.81758 11.9412 5.79994 11.9471 5.7823C11.9588 5.74703 11.9706 5.71175 11.9824 5.67059C11.9941 5.6118 12 5.553 12 5.49421C12 5.43541 11.9941 5.37662 11.9824 5.31783C11.9765 5.28255 11.9588 5.24139 11.9471 5.20612C11.9412 5.18848 11.9353 5.17084 11.9294 5.1532C11.9118 5.11204 11.8883 5.07677 11.8707 5.03561C11.8648 5.02385 11.8589 5.01209 11.853 5.00033C11.8236 4.9533 11.7825 4.90626 11.7413 4.86511L7.89025 1.01993C7.54336 0.673043 6.98481 0.673043 6.6438 1.01993C6.30279 1.36682 6.29691 1.92537 6.6438 2.26638L7.26703 2.8896L8.99559 4.61817H0.881921C0.393925 4.61817 0 5.01209 0 5.50009C0 5.98808 0.393925 6.38201 0.881921 6.38201H8.99559L7.26703 8.11057L6.6438 8.7338C6.29691 9.08069 6.29691 9.63924 6.6438 9.98025C6.81431 10.1508 7.04361 10.2389 7.26703 10.2389C7.49045 10.2389 7.71975 10.1508 7.89025 9.98025L11.7472 6.12331C11.7883 6.08216 11.8236 6.03512 11.8589 5.98808H11.853Z"
                          fill="#000538"
                        />
                      </svg>
                    </span> */}
                  </a>
                );
              })}
            </div>
          </div>
        )}
        {data?.col2 && (
          <div className={`w-full lg:max-w-[${data.col2.width}]`}>
            <button
              onClick={() => {
                setMobileActive(1);
              }}
              className="w-full flex items-center pointer-events-auto lg:pointer-events-none lg:uppercase lg:text-[12px] lg:text-[#00A3A3] font-bold pb-1.5 lg:pb-3 pt-1.5 lg:pt-0 px-[16px] lg:px-0 lg:tracking-[1.5px]"
              style={{ margin: "0" }}
            >
              {data.col2.title}
              <svg
                className="ml-auto block lg:hidden"
                width="10"
                height="14"
                viewBox="0 0 10 14"
                fill="#000538"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.456758 12.355L6.07297 7L0.456757 1.645L2.18576 8.77371e-08L9.54324 7L2.18576 14L0.456758 12.355Z"
                  fill="#0738F1"
                />
              </svg>
            </button>

            <div
              style={{
                gridTemplateColumns: `repeat(${data.col2.colNum}, minmax(0, 1fr))`,
              }}
              className={`h-full lg:h-auto lg:grid top-[80px] lg:top-0 absolute lg:relative bg-[#fff] w-full transition-all transform lg:transform-none ${
                mobileActive === 1 ? "translate-x-[0%]" : "translate-x-[100%]"
              }`}
            >
              <BackButton />
              <p className="m-0 pt-[16px] uppercase text-[#0738F1] block lg:hidden tracking-[2px] px-[16px]">
                <span className="border-b pb-[16px] lg:pb-0 block w-full">
                  {data.col2.title}
                </span>
              </p>
              {data.col2.items.map((item, index) => {
                return (
                  <a
                    key={index + Math.random()}
                    style={{
                      color: "var(--lacework-text)",
                      fontWeight: "400",
                    }}
                    className="flex items-center text-[16px] lg:text-[14px] svg-hover col-items primary-nav-child"
                    href={item?.link || "/"}
                    target={item?.targetBlank ? "_blank" : "_self"}
                  >
                    <span className="border-b lg:border-b-0 w-full lg:w-auto">
                      {item.title}
                    </span>
                    {/* <span
                      className="transform translate-x-2"
                      style={{ marginLeft: "-5px" }}
                    >
                      <svg
                        className="hidden lg:block"
                        width="12"
                        height="11"
                        viewBox="0 0 12 11"
                        fill="#000538"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M11.853 5.98808C11.853 5.98808 11.8648 5.96457 11.8707 5.95281C11.8942 5.91753 11.9177 5.87637 11.9294 5.83522C11.9353 5.81758 11.9412 5.79994 11.9471 5.7823C11.9588 5.74703 11.9706 5.71175 11.9824 5.67059C11.9941 5.6118 12 5.553 12 5.49421C12 5.43541 11.9941 5.37662 11.9824 5.31783C11.9765 5.28255 11.9588 5.24139 11.9471 5.20612C11.9412 5.18848 11.9353 5.17084 11.9294 5.1532C11.9118 5.11204 11.8883 5.07677 11.8707 5.03561C11.8648 5.02385 11.8589 5.01209 11.853 5.00033C11.8236 4.9533 11.7825 4.90626 11.7413 4.86511L7.89025 1.01993C7.54336 0.673043 6.98481 0.673043 6.6438 1.01993C6.30279 1.36682 6.29691 1.92537 6.6438 2.26638L7.26703 2.8896L8.99559 4.61817H0.881921C0.393925 4.61817 0 5.01209 0 5.50009C0 5.98808 0.393925 6.38201 0.881921 6.38201H8.99559L7.26703 8.11057L6.6438 8.7338C6.29691 9.08069 6.29691 9.63924 6.6438 9.98025C6.81431 10.1508 7.04361 10.2389 7.26703 10.2389C7.49045 10.2389 7.71975 10.1508 7.89025 9.98025L11.7472 6.12331C11.7883 6.08216 11.8236 6.03512 11.8589 5.98808H11.853Z"
                          fill="#000538"
                        />
                      </svg>
                    </span> */}
                  </a>
                );
              })}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

const MegaMenuA = ({ data, primaryLink, primaryLinkData }) => {
  const [active, setActive] = useState(0);
  const [mobileActive, setMobileActive] = useState(-1);
  // const maxWidth =
  //   data[0].title === "capabilities" ? "lg:max-w-[882px]" : "";

  return (
    <div
      style={{
        left: "30px",
      }}
      className={`lg:absolute top-[0px] lg:top-[85%] w-full lg:rounded-2xl lg:overflow-hidden lg:bg-[#EDF0FF] lg:hidden lg:group-hover:block lg:shadow-[rgba(0,0,0,0.25)_0px_15px_15px_0px] lg:w-[calc(100%-60px)]`}
    >
      <style>{`
        @media (min-width: 1024px) {
          .menu-1-height {
            height: 440px !important;
          }
        }
      `}</style>
      <div
        className={`lg:flex lg:flex-col lg:relative lg:h-[365px] ${
          primaryLink === "platform" ? "menu-1-height" : ""
        }`}
      >
        <style>{`
          .other-padding-btns {
            padding-top: 3.75px;
            padding-bottom: 3.75px;
          }

          .padding-top-btns {
            padding-top: 3.75px;
            padding-bottom: 3.75px;
          }

          @media (min-width: 1024px) {
            .padding-top-btns {
              padding-top: 30px;
              padding-bottom: 15px;
            }
            
            .other-padding-btns {
              padding-top: 15px;
              padding-bottom: 15px;
            }
          }
          
        `}</style>
        <a
          className="w-full lg:max-w-[220px] svg-hover px-[16px] lg:px-0 py-1.5 lg:py-0 primary-nav-parent"
          href={primaryLinkData?.link}
        >
          <style>{`
            .primary-link-padding {
              padding: 0px 0px 0px 0px;
            }

            @media (min-width: 1024px) {
              .primary-link-padding {
                padding: 28px 28px 0px 28px;
              }
            }
          `}</style>
          <div className="primary-link-padding">
            <p className="flex items-center lg:pb-1" style={{ margin: 0 }}>
              <span className="lg:text-[16px] font-normal lg:font-bold ">
                {primaryLinkData?.title}
              </span>
              <span>
                <svg
                  className="hidden lg:block"
                  width="12"
                  height="11"
                  viewBox="0 0 12 11"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M11.853 5.98808C11.853 5.98808 11.8648 5.96457 11.8707 5.95281C11.8942 5.91753 11.9177 5.87637 11.9294 5.83522C11.9353 5.81758 11.9412 5.79994 11.9471 5.7823C11.9588 5.74703 11.9706 5.71175 11.9824 5.67059C11.9941 5.6118 12 5.553 12 5.49421C12 5.43541 11.9941 5.37662 11.9824 5.31783C11.9765 5.28255 11.9588 5.24139 11.9471 5.20612C11.9412 5.18848 11.9353 5.17084 11.9294 5.1532C11.9118 5.11204 11.8883 5.07677 11.8707 5.03561C11.8648 5.02385 11.8589 5.01209 11.853 5.00033C11.8236 4.9533 11.7825 4.90626 11.7413 4.86511L7.89025 1.01993C7.54336 0.673043 6.98481 0.673043 6.6438 1.01993C6.30279 1.36682 6.29691 1.92537 6.6438 2.26638L7.26703 2.8896L8.99559 4.61817H0.881921C0.393925 4.61817 0 5.01209 0 5.50009C0 5.98808 0.393925 6.38201 0.881921 6.38201H8.99559L7.26703 8.11057L6.6438 8.7338C6.29691 9.08069 6.29691 9.63924 6.6438 9.98025C6.81431 10.1508 7.04361 10.2389 7.26703 10.2389C7.49045 10.2389 7.71975 10.1508 7.89025 9.98025L11.7472 6.12331C11.7883 6.08216 11.8236 6.03512 11.8589 5.98808H11.853Z"
                    fill="#000538"
                  />
                </svg>
              </span>
            </p>
            <p
              className="hidden lg:block text-[14px] text-[#8289A1]"
              style={{
                margin: "0",
                borderBottom: "1px solid #BCC3E5",
                paddingBottom: "16px",
              }}
            >
              {primaryLinkData?.description}
            </p>
          </div>
        </a>
        {data &&
          data.map((item, index) => {
            const visible = active === index;

            return (
              <button
                // key={index + Math.random()}
                onClick={() => {
                  setMobileActive(index);
                }}
                onMouseEnter={() => {
                  setActive(index);
                }}
                style={{
                  textTransform: "capitalize",
                }}
                className={`${
                  visible ? "lg:text-[#0738F1]" : ""
                } transition text-left lg:text-[16px] w-full max-w-full lg:max-w-[220px] lg:pt-[16px] relative flex items-center px-[16px] lg:px-[28px] lg:py-0 lg:font-normal ${
                  index === 0 ? "padding-top-btns" : "other-padding-btns"
                }`}
              >
                {item?.title?.toLowerCase()}
                <svg
                  style={{
                    zIndex: "20",
                    transform: visible
                      ? `translateX(0px)`
                      : `translateX(-12px)`,
                  }}
                  className={`absolute left-full pointer-events-none hidden lg:block transition`}
                  width="12"
                  height="27"
                  viewBox="0 0 12 27"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.9961 11.4191L0 -5.68248e-07L-1.18021e-06 27L10.9961 15.5809C12.1149 14.4192 12.1149 12.5808 10.9961 11.4191Z"
                    fill="#EDF7FF"
                  />
                </svg>
                <svg
                  className="ml-auto block lg:hidden"
                  width="10"
                  height="14"
                  viewBox="0 0 10 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0.456758 12.355L6.07297 7L0.456757 1.645L2.18576 8.77371e-08L9.54324 7L2.18576 14L0.456758 12.355Z"
                    fill="#0738F1"
                  />
                </svg>
              </button>
            );
          })}
        {data &&
          data.map((menu, menuIndex) => {
            if (
              menu.title.toLowerCase() === "capabilities" ||
              menu.title.toLowerCase() === "möglichkeiten" ||
              menu.title.toLowerCase() === "capacités"
            ) {
              return (
                <div
                  // key={Math.random() + menuIndex}
                  id={`menu-${menuIndex + 1}`}
                  className={`transition-all transform lg:transform-none absolute top-[80px] lg:top-0 lg:left-[220px] bg-[#fff] lg:px-16 h-full  w-full lg:w-[calc(100%-220px)] z-10 mega-menu-col-container  ${
                    active === menuIndex || (active === -1 && menuIndex === 0)
                      ? ""
                      : "hidden"
                  } ${
                    mobileActive !== menuIndex
                      ? "translate-x-[100%]"
                      : "translate-x-[0%]"
                  }`}
                >
                  <button
                    onClick={() => {
                      setMobileActive(-1);
                    }}
                    className="flex items-center gap-3 lg:hidden px-[16px] font-normal pt-[16px] pb-2"
                  >
                    <span>
                      <svg
                        width="10"
                        height="14"
                        viewBox="0 0 10 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M9.54324 1.645L3.92703 7L9.54324 12.355L7.81424 14L0.456757 7L7.81424 8.77371e-08L9.54324 1.645Z"
                          fill="#0738F1"
                        />
                      </svg>
                    </span>
                    <span>Back</span>
                  </button>
                  <p className="m-0 pt-[16px] uppercase text-[#0738F1] block lg:hidden tracking-[2px] px-[16px]">
                    <span className="border-b pb-[16px] lg:pb-0 block w-full">
                      {menu?.title?.toLowerCase()}
                    </span>
                  </p>
                  <div
                    className={`lg:grid ${
                      data[0].title === "capabilities" ? "grid-cols-2" : ""
                    }  justify-center`}
                    style={{ gap: "0px 25px" }}
                  >
                    <style>
                      {`
                      .mega-menu-link .mega-menu-link-description {
                        transition: color .2s ease;
                        color: #8289A1;
                      }
  
                      .mega-menu-link:hover .mega-menu-link-description {
                        color: var(--lacework-text);
                      }
                      .hide-text-on-desktop {
                        display: none;
                      }

                      @media (min-width: 1240px) {
                        .hide-text-on-desktop {
                          display: block;
                        }
                      }
                    `}
                    </style>
                    <div
                      className="lg:py-[28px] lg:flex w-full"
                      style={{ gap: "5rem" }}
                    >
                      <div className="lg:w-full lg:max-w-[255px]">
                        <p
                          className="m-0 px-[16px] lg:px-0 nav-heading-padding"
                          style={{
                            fontSize: "14px",
                            lineHeight: "24px",
                            color: "#677ED0",
                            letterSpacing: "3px",
                            textTransform: "uppercase",
                            fontWeight: "600",
                          }}
                        >
                          Code Security
                        </p>
                        {[
                          {
                            icon: (
                              <svg
                                style={{ maxWidth: "25px", maxHeight: "25px" }}
                                class="no-hover"
                                width="31"
                                height="17"
                                viewBox="0 0 31 17"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M6.43622 2.33063C6.92402 2.33063 7.41183 2.52034 7.79124 2.89974C8.52295 3.63145 8.52295 4.85097 7.79124 5.58268L4.81019 8.56373L7.79124 11.5448C8.17064 11.9242 8.36035 12.412 8.36035 12.8998C8.36035 13.3876 8.17064 13.8754 7.79124 14.2548C7.05953 15.0136 5.84001 15.0136 5.1083 14.2548L0.772233 9.89165C0.392828 9.51224 0.203125 9.02444 0.203125 8.53663C0.203125 8.04882 0.392828 7.56101 0.772233 7.18161L5.1083 2.84554C5.4877 2.46614 5.97551 2.27643 6.46332 2.27643L6.43622 2.33063ZM17.3848 0.948514L9.74247 14.0922C9.20046 15.0136 9.52566 16.1789 10.42 16.6938C11.3143 17.2359 12.5067 16.9107 13.0216 16.0163L20.6639 2.87264C21.2059 1.95123 20.8807 0.785912 19.9864 0.271004C19.6883 0.108402 19.3631 0 19.0379 0C18.3875 0 17.7371 0.352305 17.3848 0.948514ZM23.9431 14.7968C23.4553 14.7968 22.9675 14.6071 22.5881 14.2277C21.8563 13.496 21.8563 12.2765 22.5881 11.5448L25.5691 8.56373L22.5881 5.58268C22.2087 5.20328 22.0189 4.71547 22.0189 4.22766C22.0189 3.73986 22.2087 3.25205 22.5881 2.87264C23.3198 2.11383 24.5393 2.11383 25.271 2.87264L29.6071 7.20871C29.9865 7.58811 30.1762 8.07592 30.1762 8.56373C30.1762 9.05153 29.9865 9.53934 29.6071 9.91875L25.271 14.2548C24.8916 14.6342 24.4038 14.8239 23.916 14.8239L23.9431 14.7968Z"
                                  fill="url(#paint0_linear_587_5550)"
                                ></path>
                                <defs>
                                  <linearGradient
                                    id="paint0_linear_587_5550"
                                    x1="7.30343"
                                    y1="16.4499"
                                    x2="25.7031"
                                    y2="-1.94975"
                                    gradientUnits="userSpaceOnUse"
                                  >
                                    <stop stop-color="#64D3DD"></stop>
                                    <stop
                                      offset="1"
                                      stop-color="#3381E8"
                                    ></stop>
                                  </linearGradient>
                                </defs>
                              </svg>
                            ),
                            link: "https://www.lacework.com/solutions/code-security",
                            title: "Code Security",
                            description:
                              "Quickly prioritize and fix first and third-party code risks",
                          },
                          {
                            icon: (
                              <svg
                                style={{ maxWidth: "25px", maxHeight: "25px" }}
                                class="no-hover"
                                width="31"
                                height="17"
                                viewBox="0 0 31 17"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M6.43622 2.33063C6.92402 2.33063 7.41183 2.52034 7.79124 2.89974C8.52295 3.63145 8.52295 4.85097 7.79124 5.58268L4.81019 8.56373L7.79124 11.5448C8.17064 11.9242 8.36035 12.412 8.36035 12.8998C8.36035 13.3876 8.17064 13.8754 7.79124 14.2548C7.05953 15.0136 5.84001 15.0136 5.1083 14.2548L0.772233 9.89165C0.392828 9.51224 0.203125 9.02444 0.203125 8.53663C0.203125 8.04882 0.392828 7.56101 0.772233 7.18161L5.1083 2.84554C5.4877 2.46614 5.97551 2.27643 6.46332 2.27643L6.43622 2.33063ZM17.3848 0.948514L9.74247 14.0922C9.20046 15.0136 9.52566 16.1789 10.42 16.6938C11.3143 17.2359 12.5067 16.9107 13.0216 16.0163L20.6639 2.87264C21.2059 1.95123 20.8807 0.785912 19.9864 0.271004C19.6883 0.108402 19.3631 0 19.0379 0C18.3875 0 17.7371 0.352305 17.3848 0.948514ZM23.9431 14.7968C23.4553 14.7968 22.9675 14.6071 22.5881 14.2277C21.8563 13.496 21.8563 12.2765 22.5881 11.5448L25.5691 8.56373L22.5881 5.58268C22.2087 5.20328 22.0189 4.71547 22.0189 4.22766C22.0189 3.73986 22.2087 3.25205 22.5881 2.87264C23.3198 2.11383 24.5393 2.11383 25.271 2.87264L29.6071 7.20871C29.9865 7.58811 30.1762 8.07592 30.1762 8.56373C30.1762 9.05153 29.9865 9.53934 29.6071 9.91875L25.271 14.2548C24.8916 14.6342 24.4038 14.8239 23.916 14.8239L23.9431 14.7968Z"
                                  fill="url(#paint0_linear_587_5550)"
                                ></path>
                                <defs>
                                  <linearGradient
                                    id="paint0_linear_587_5550"
                                    x1="7.30343"
                                    y1="16.4499"
                                    x2="25.7031"
                                    y2="-1.94975"
                                    gradientUnits="userSpaceOnUse"
                                  >
                                    <stop stop-color="#64D3DD"></stop>
                                    <stop
                                      offset="1"
                                      stop-color="#3381E8"
                                    ></stop>
                                  </linearGradient>
                                </defs>
                              </svg>
                            ),
                            link: "https://www.lacework.com/solutions/infrastructure-as-code/",
                            title: "Infrastructure as Code Security (IaC)",
                            description:
                              "Fix misconfigurations before code is deployed",
                          },
                          {
                            icon: (
                              <svg
                                style={{ maxWidth: "25px", maxHeight: "25px" }}
                                class="no-hover"
                                width="31"
                                height="17"
                                viewBox="0 0 31 17"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M6.43622 2.33063C6.92402 2.33063 7.41183 2.52034 7.79124 2.89974C8.52295 3.63145 8.52295 4.85097 7.79124 5.58268L4.81019 8.56373L7.79124 11.5448C8.17064 11.9242 8.36035 12.412 8.36035 12.8998C8.36035 13.3876 8.17064 13.8754 7.79124 14.2548C7.05953 15.0136 5.84001 15.0136 5.1083 14.2548L0.772233 9.89165C0.392828 9.51224 0.203125 9.02444 0.203125 8.53663C0.203125 8.04882 0.392828 7.56101 0.772233 7.18161L5.1083 2.84554C5.4877 2.46614 5.97551 2.27643 6.46332 2.27643L6.43622 2.33063ZM17.3848 0.948514L9.74247 14.0922C9.20046 15.0136 9.52566 16.1789 10.42 16.6938C11.3143 17.2359 12.5067 16.9107 13.0216 16.0163L20.6639 2.87264C21.2059 1.95123 20.8807 0.785912 19.9864 0.271004C19.6883 0.108402 19.3631 0 19.0379 0C18.3875 0 17.7371 0.352305 17.3848 0.948514ZM23.9431 14.7968C23.4553 14.7968 22.9675 14.6071 22.5881 14.2277C21.8563 13.496 21.8563 12.2765 22.5881 11.5448L25.5691 8.56373L22.5881 5.58268C22.2087 5.20328 22.0189 4.71547 22.0189 4.22766C22.0189 3.73986 22.2087 3.25205 22.5881 2.87264C23.3198 2.11383 24.5393 2.11383 25.271 2.87264L29.6071 7.20871C29.9865 7.58811 30.1762 8.07592 30.1762 8.56373C30.1762 9.05153 29.9865 9.53934 29.6071 9.91875L25.271 14.2548C24.8916 14.6342 24.4038 14.8239 23.916 14.8239L23.9431 14.7968Z"
                                  fill="url(#paint0_linear_587_5550)"
                                ></path>
                                <defs>
                                  <linearGradient
                                    id="paint0_linear_587_5550"
                                    x1="7.30343"
                                    y1="16.4499"
                                    x2="25.7031"
                                    y2="-1.94975"
                                    gradientUnits="userSpaceOnUse"
                                  >
                                    <stop stop-color="#64D3DD"></stop>
                                    <stop
                                      offset="1"
                                      stop-color="#3381E8"
                                    ></stop>
                                  </linearGradient>
                                </defs>
                              </svg>
                            ),
                            link: "https://www.lacework.com/platform/sca-sbom",
                            title: "Software Composition Analysis (SCA)",
                            description:
                              "Detect third-party software risks and build SBOMs",
                          },
                          {
                            icon: (
                              <svg
                                style={{ maxWidth: "25px", maxHeight: "25px" }}
                                class="no-hover"
                                width="31"
                                height="17"
                                viewBox="0 0 31 17"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M6.43622 2.33063C6.92402 2.33063 7.41183 2.52034 7.79124 2.89974C8.52295 3.63145 8.52295 4.85097 7.79124 5.58268L4.81019 8.56373L7.79124 11.5448C8.17064 11.9242 8.36035 12.412 8.36035 12.8998C8.36035 13.3876 8.17064 13.8754 7.79124 14.2548C7.05953 15.0136 5.84001 15.0136 5.1083 14.2548L0.772233 9.89165C0.392828 9.51224 0.203125 9.02444 0.203125 8.53663C0.203125 8.04882 0.392828 7.56101 0.772233 7.18161L5.1083 2.84554C5.4877 2.46614 5.97551 2.27643 6.46332 2.27643L6.43622 2.33063ZM17.3848 0.948514L9.74247 14.0922C9.20046 15.0136 9.52566 16.1789 10.42 16.6938C11.3143 17.2359 12.5067 16.9107 13.0216 16.0163L20.6639 2.87264C21.2059 1.95123 20.8807 0.785912 19.9864 0.271004C19.6883 0.108402 19.3631 0 19.0379 0C18.3875 0 17.7371 0.352305 17.3848 0.948514ZM23.9431 14.7968C23.4553 14.7968 22.9675 14.6071 22.5881 14.2277C21.8563 13.496 21.8563 12.2765 22.5881 11.5448L25.5691 8.56373L22.5881 5.58268C22.2087 5.20328 22.0189 4.71547 22.0189 4.22766C22.0189 3.73986 22.2087 3.25205 22.5881 2.87264C23.3198 2.11383 24.5393 2.11383 25.271 2.87264L29.6071 7.20871C29.9865 7.58811 30.1762 8.07592 30.1762 8.56373C30.1762 9.05153 29.9865 9.53934 29.6071 9.91875L25.271 14.2548C24.8916 14.6342 24.4038 14.8239 23.916 14.8239L23.9431 14.7968Z"
                                  fill="url(#paint0_linear_587_5550)"
                                ></path>
                                <defs>
                                  <linearGradient
                                    id="paint0_linear_587_5550"
                                    x1="7.30343"
                                    y1="16.4499"
                                    x2="25.7031"
                                    y2="-1.94975"
                                    gradientUnits="userSpaceOnUse"
                                  >
                                    <stop stop-color="#64D3DD"></stop>
                                    <stop
                                      offset="1"
                                      stop-color="#3381E8"
                                    ></stop>
                                  </linearGradient>
                                </defs>
                              </svg>
                            ),
                            link: "https://www.lacework.com/platform/sast",
                            title: "Static Application Security Testing (SAST)",
                            description:
                              "Find security weaknesses in your in-house code",
                          },
                        ].map((menuItem) => {
                          const id = Math.floor(Math.random() * 100);

                          return (
                            <a
                              href={menuItem?.link}
                              // key={id + Math.random()}
                              className={`flex px-[16px] lg:px-0 lg:pb-0  ${
                                data[0].title === "capabilities"
                                  ? "lg:pt-[28px]"
                                  : "lg:pt-[20px]"
                              } svg-hover mega-menu-link primary-nav-child`}
                            >
                              {primaryLink && menuItem?.icon && (
                                <div className="lg:mr-[12px] hidden lg:block">
                                  {menuItem.icon}
                                </div>
                              )}
                              <div className="border-b lg:border-b-0 py-[1rem] lg:py-0 w-full">
                                <p
                                  className="text-[16px] lg:text-[14px] flex items-center"
                                  style={{ margin: "0", paddingBottom: "2px" }}
                                >
                                  <style>{`
                                    .nav-item-arrow {
                                      display: none;
                                    }
      
                                    @media (min-width: 1024px) {
                                      .nav-item-arrow {
                                        display: inline;
                                        margin-top: -2px;
                                      } 
                                    }
                                  `}</style>
                                  <span>
                                    <span
                                      dangerouslySetInnerHTML={{
                                        __html: menuItem.title,
                                      }}
                                    />
                                    {/* <svg
                                      className="nav-item-arrow"
                                      width="12"
                                      height="11"
                                      viewBox="0 0 12 11"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M11.853 5.98808C11.853 5.98808 11.8648 5.96457 11.8707 5.95281C11.8942 5.91753 11.9177 5.87637 11.9294 5.83522C11.9353 5.81758 11.9412 5.79994 11.9471 5.7823C11.9588 5.74703 11.9706 5.71175 11.9824 5.67059C11.9941 5.6118 12 5.553 12 5.49421C12 5.43541 11.9941 5.37662 11.9824 5.31783C11.9765 5.28255 11.9588 5.24139 11.9471 5.20612C11.9412 5.18848 11.9353 5.17084 11.9294 5.1532C11.9118 5.11204 11.8883 5.07677 11.8707 5.03561C11.8648 5.02385 11.8589 5.01209 11.853 5.00033C11.8236 4.9533 11.7825 4.90626 11.7413 4.86511L7.89025 1.01993C7.54336 0.673043 6.98481 0.673043 6.6438 1.01993C6.30279 1.36682 6.29691 1.92537 6.6438 2.26638L7.26703 2.8896L8.99559 4.61817H0.881921C0.393925 4.61817 0 5.01209 0 5.50009C0 5.98808 0.393925 6.38201 0.881921 6.38201H8.99559L7.26703 8.11057L6.6438 8.7338C6.29691 9.08069 6.29691 9.63924 6.6438 9.98025C6.81431 10.1508 7.04361 10.2389 7.26703 10.2389C7.49045 10.2389 7.71975 10.1508 7.89025 9.98025L11.7472 6.12331C11.7883 6.08216 11.8236 6.03512 11.8589 5.98808H11.853Z"
                                        fill="#000538"
                                      />
                                    </svg> */}
                                  </span>
                                </p>
                                <p
                                  className="text-[14px] mega-menu-link-description hide-text-on-desktop"
                                  style={{ margin: "0" }}
                                >
                                  {menuItem.description}
                                </p>
                              </div>
                            </a>
                          );
                        })}
                      </div>
                      <div>
                        <p
                          className="m-0 px-[16px] lg:px-0 nav-heading-padding"
                          style={{
                            fontSize: "14px",
                            lineHeight: "24px",
                            color: "#677ED0",
                            letterSpacing: "3px",
                            textTransform: "uppercase",
                            fontWeight: "600",
                          }}
                        >
                          Cloud Security
                        </p>
                        <div
                          className="lg:grid grid-cols-2"
                          style={{ gap: "0px 10px" }}
                        >
                          {[
                            {
                              icon: (
                                <svg
                                  style={{
                                    maxWidth: "25px",
                                    maxHeight: "25px",
                                  }}
                                  class="no-hover"
                                  width="30"
                                  height="21"
                                  viewBox="0 0 30 21"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M19.6041 9.7627V14.6967C19.6041 19.3669 24.4326 20.95 24.4326 20.95C24.4326 20.95 29.2611 19.3669 29.2611 14.6967V9.7627H19.6305H19.6041Z"
                                    fill="#47A2E4"
                                  ></path>
                                  <path
                                    d="M20.686 3.79947C19.1029 1.4248 16.4644 0 13.6148 0C9.89446 0 6.67546 2.45383 5.5409 5.91029C2.40106 6.54353 0 9.31398 0 12.6385C0 15.9631 2.18997 18.6016 5.14512 19.2876C5.67282 19.4723 6.22691 19.5514 6.80739 19.5514H15.3034C16.2797 19.5514 17.0976 18.7599 17.0976 17.7573C17.0976 16.7546 16.3061 15.9631 15.3034 15.9631H6.80739C6.64908 15.9631 6.46438 15.9367 6.12137 15.8311C4.61741 15.4881 3.56201 14.1689 3.56201 12.6121C3.56201 10.7916 5.03958 9.31398 6.86016 9.31398C6.86016 9.31398 6.86016 9.31398 6.88654 9.31398C6.88654 9.31398 6.91293 9.31398 6.93931 9.31398C7.83641 9.31398 8.5752 8.65435 8.70712 7.78364C9.05013 5.38259 11.1609 3.562 13.5884 3.562C15.2507 3.562 16.781 4.37995 17.7045 5.77836C18.2586 6.59631 19.3668 6.83377 20.1847 6.27968C21.0026 5.72559 21.2401 4.61741 20.686 3.79947Z"
                                    fill="url(#paint0_linear_587_5530)"
                                  ></path>
                                  <defs>
                                    <linearGradient
                                      id="paint0_linear_587_5530"
                                      x1="3.08707"
                                      y1="19.6042"
                                      x2="20.3166"
                                      y2="2.37467"
                                      gradientUnits="userSpaceOnUse"
                                    >
                                      <stop stop-color="#64D3DD"></stop>
                                      <stop
                                        offset="1"
                                        stop-color="#3381E8"
                                      ></stop>
                                    </linearGradient>
                                  </defs>
                                </svg>
                              ),
                              link: "https://www.lacework.com/platform/",
                              title:
                                "Cloud-Native Application Protection Platform (CNAPP)",
                              description:
                                "Secure across the entire application lifecycle",
                            },
                            {
                              icon: (
                                <svg
                                  style={{
                                    maxWidth: "25px",
                                    maxHeight: "25px",
                                  }}
                                  class="no-hover"
                                  width="25"
                                  height="28"
                                  viewBox="0 0 25 28"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M0.108182 1.82058V12.4538C0.108182 21.4512 7.70713 26.3061 11.7177 27.6253C11.9024 27.6781 12.0871 27.7045 12.2718 27.7045C12.4565 27.7045 12.6412 27.6781 12.8259 27.6253C16.8364 26.3061 24.4354 21.4248 24.4354 12.4274V1.7942C24.4354 0.817943 23.6438 0 22.6412 0H1.84962C0.873363 0 0.0554199 0.791557 0.0554199 1.7942L0.108182 1.82058ZM3.67019 3.61477H20.8997V12.4538C20.8997 19.9208 14.3034 23.219 12.2982 24.0369C10.2929 23.219 3.69657 19.9208 3.69657 12.4538V3.61477H3.67019Z"
                                    fill="url(#paint0_linear_587_5545)"
                                  ></path>
                                  <path
                                    d="M9.55405 17.3615L5.99205 13.7731C5.30604 13.0607 5.30604 11.9525 5.99205 11.2401C6.70445 10.5541 7.83901 10.5541 8.52503 11.2401L10.8469 13.5884L16.7836 7.67809C17.4696 6.99207 18.6042 6.99207 19.3166 7.67809C20.0026 8.39049 20.0026 9.49866 19.3166 10.2111L12.1662 17.3351C11.9815 17.5198 11.744 17.6517 11.5066 17.7309C11.2955 17.81 11.058 17.8628 10.8205 17.8628C10.372 17.8628 9.89706 17.6781 9.55405 17.3351V17.3615Z"
                                    fill="#4EAEE2"
                                  ></path>
                                  <defs>
                                    <linearGradient
                                      id="paint0_linear_587_5545"
                                      x1="1.82323"
                                      y1="20.343"
                                      x2="22.7731"
                                      y2="-0.606859"
                                      gradientUnits="userSpaceOnUse"
                                    >
                                      <stop stop-color="#64D3DD"></stop>
                                      <stop
                                        offset="1"
                                        stop-color="#3381E8"
                                      ></stop>
                                    </linearGradient>
                                  </defs>
                                </svg>
                              ),
                              link: "https://www.lacework.com/platform/threat-detection/",
                              title:
                                "Cloud Workload Protection Platform (CWPP)",
                              description:
                                "Monitor workloads continuously for threats",
                            },
                            {
                              icon: (
                                <svg
                                  style={{
                                    maxWidth: "25px",
                                    maxHeight: "25px",
                                  }}
                                  class="no-hover"
                                  width="23"
                                  height="30"
                                  viewBox="0 0 23 30"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M1.73347 29.8681H20.7044C21.5752 29.8681 22.2612 29.1557 22.2612 28.3113V14.9604C22.2612 14.0897 21.5488 13.4037 20.7044 13.4037H19.649V8.41688C19.649 3.77308 15.876 0 11.2322 0C6.58835 0 2.81526 3.77308 2.81526 8.41688V13.4037H1.75985C0.889141 13.4037 0.203125 14.1161 0.203125 14.9604V28.3113C0.203125 29.1821 0.915526 29.8681 1.75985 29.8681H1.73347ZM19.1477 26.7282H3.31658V16.5171H19.1477V26.7282ZM5.9551 8.3905C5.9551 5.48812 8.32978 3.11345 11.2322 3.11345C14.1345 3.11345 16.5092 5.48812 16.5092 8.3905V13.3773H5.92872V8.3905H5.9551Z"
                                    fill="url(#paint0_linear_587_5533)"
                                  ></path>
                                  <path
                                    d="M9.43787 21.6091C9.43787 20.6329 10.2294 19.8149 11.2321 19.8149C12.2347 19.8149 13.0263 20.6065 13.0263 21.6091C13.0263 22.6118 12.2347 23.4033 11.2321 23.4033C10.2294 23.4033 9.43787 22.6118 9.43787 21.6091Z"
                                    fill="#4EAEE2"
                                  ></path>
                                  <defs>
                                    <linearGradient
                                      id="paint0_linear_587_5533"
                                      x1="0.361437"
                                      y1="29.1029"
                                      x2="22.1029"
                                      y2="7.36147"
                                      gradientUnits="userSpaceOnUse"
                                    >
                                      <stop stop-color="#64D3DD"></stop>
                                      <stop
                                        offset="1"
                                        stop-color="#3381E8"
                                      ></stop>
                                    </linearGradient>
                                  </defs>
                                </svg>
                              ),
                              link: "https://www.lacework.com/platform/cloud-infrastructure-entitlement-management-ciem/",
                              title:
                                "Cloud Infrastructure Entitlement Management (CIEM)",
                              description:
                                "Reduce cloud identity security risks",
                            },
                            {
                              icon: (
                                <svg
                                  style={{
                                    maxWidth: "25px",
                                    maxHeight: "25px",
                                  }}
                                  className="no-hover"
                                  width="32"
                                  height="25"
                                  viewBox="0 0 32 25"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M0.0263808 12.6385C0.0263808 9.31398 2.40106 6.51715 5.56728 5.91029C6.67546 2.48021 9.92084 0 13.6148 0C16.4644 0 19.1029 1.4248 20.686 3.79947C21.2401 4.61741 21.0026 5.72559 20.1847 6.27968C19.3667 6.83377 18.2586 6.59631 17.7045 5.77836C16.781 4.40633 15.2507 3.562 13.5884 3.562C11.1609 3.562 9.05013 5.38258 8.70712 7.78364C8.57519 8.65435 7.8364 9.31398 6.93931 9.31398C6.91292 9.31398 6.88654 9.31398 6.86015 9.31398C5.03957 9.31398 3.562 10.7916 3.562 12.6121C3.562 14.1425 4.61741 15.4881 6.12137 15.8311C6.46438 15.9367 6.62269 15.9631 6.80738 15.9631H11.2929C12.2691 15.9631 13.0871 16.7546 13.0871 17.7573C13.0871 18.7599 12.2955 19.5514 11.2929 19.5514H6.80738C6.25329 19.5514 5.69921 19.4723 5.14512 19.2876C2.18998 18.6016 0 15.8575 0 12.6385H0.0263808Z"
                                    fill="url(#paint0_linear_587_5551)"
                                  />
                                  <path
                                    d="M30.5277 21.1348L27.8628 18.4699C28.3377 17.5728 28.6015 16.5702 28.6015 15.4884C28.6015 11.8472 25.6464 8.89209 22.0052 8.89209C18.3641 8.89209 15.4089 11.8472 15.4089 15.4884C15.4089 19.1296 18.3641 22.0847 22.0052 22.0847C23.2717 22.0847 24.4327 21.7153 25.4353 21.1084L27.9947 23.6678C28.3377 24.0108 28.8126 24.1955 29.2612 24.1955C29.7097 24.1955 30.1847 24.0108 30.5277 23.6678C31.2137 22.9818 31.2137 21.8472 30.5277 21.1348ZM22.0052 18.5227C20.343 18.5227 18.9709 17.1507 18.9709 15.4884C18.9709 13.8261 20.343 12.4541 22.0052 12.4541C23.6675 12.4541 25.0395 13.8261 25.0395 15.4884C25.0395 17.1507 23.6675 18.5227 22.0052 18.5227Z"
                                    fill="#47A2E4"
                                  />
                                  <defs>
                                    <linearGradient
                                      id="paint0_linear_587_5551"
                                      x1="1.29288"
                                      y1="19.4195"
                                      x2="22.0317"
                                      y2="-1.31926"
                                      gradientUnits="userSpaceOnUse"
                                    >
                                      <stop stop-color="#64D3DD" />
                                      <stop offset="1" stop-color="#3381E8" />
                                    </linearGradient>
                                  </defs>
                                </svg>
                              ),
                              link: "https://www.lacework.com/platform/cloud-security-posture-and-compliance/",
                              title: "Cloud Security Posture Management (CSPM)",
                              description:
                                "Assess and prioritize vulnerabilities and other risks",
                            },
                            {
                              icon: (
                                <svg
                                  className="no-hover"
                                  width="29"
                                  height="28"
                                  viewBox="0 0 29 28"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                  style={{
                                    maxWidth: "25px",
                                    maxHeight: "25px",
                                  }}
                                >
                                  <defs>
                                    <linearGradient
                                      id="paint0_linear_587_5548"
                                      x1="4.74668"
                                      y1="23.979"
                                      x2="24.4037"
                                      y2="4.32205"
                                      gradientUnits="userSpaceOnUse"
                                    >
                                      <stop stopColor="#64D3DD" />
                                      <stop offset="1" stopColor="#3381E8" />
                                    </linearGradient>
                                  </defs>
                                  <path
                                    d="M17.2533 16.0371L20.2876 16.5384C19.839 17.7785 18.9947 18.8603 17.8601 19.5991L16.6728 16.7495C16.5673 16.4856 16.6728 16.1954 16.9103 16.0635C16.963 16.0371 17.0422 16.0107 17.095 16.0107C17.1477 16.0107 17.1741 16.0107 17.2005 16.0107L17.2533 16.0371ZM11.5013 14.2693C11.5013 14.2693 11.686 14.1901 11.7651 14.0846C11.9498 13.8735 11.8971 13.5569 11.7124 13.3722L9.41687 11.3141C8.73085 12.4223 8.41423 13.7416 8.57254 15.1136L11.5013 14.2693ZM12.8469 11.9474C12.8469 11.9474 13.0316 12.0529 13.1372 12.0529C13.401 12.0529 13.6385 11.8418 13.6385 11.5516L13.8232 8.49092C13.6121 8.49092 13.401 8.5437 13.19 8.59647C12.0554 8.86032 11.0528 9.41441 10.2876 10.1796L12.7942 11.9738L12.8469 11.9474ZM15.4855 11.5516C15.4855 11.5516 15.5382 11.7627 15.591 11.8418C15.7757 12.0529 16.0659 12.1057 16.3034 11.9474L18.81 10.1796C17.8601 9.25609 16.6464 8.64924 15.3008 8.49092L15.4855 11.5516ZM13.7177 15.1664L14.562 15.5622L15.4063 15.1664L15.6174 14.2429L15.0369 13.5041H14.0871L13.5066 14.2429L13.7177 15.1664ZM19.7071 11.3141L17.438 13.3458C17.438 13.3458 17.306 13.5041 17.2797 13.636C17.2269 13.8999 17.3852 14.1637 17.6491 14.2429L20.6042 15.1136C20.657 14.4804 20.6042 13.8207 20.4723 13.1611C20.314 12.5015 20.0501 11.8682 19.7071 11.3141ZM15.0105 17.5411C15.0105 17.5411 14.8786 17.3827 14.7731 17.33C14.6939 17.3036 14.6148 17.2772 14.5356 17.2772C14.3509 17.2772 14.1926 17.3827 14.0871 17.5411L12.6095 20.2324C13.6385 20.5754 14.7731 20.6545 15.9076 20.3907C16.1187 20.3379 16.3034 20.2851 16.5145 20.2324L15.0369 17.5411H15.0105ZM12.0026 16.0371C12.0026 16.0371 11.9235 16.0371 11.8971 16.0371L8.88916 16.5384C9.36409 17.8313 10.2348 18.8867 11.3166 19.5727L12.4776 16.7495C12.4776 16.7495 12.5303 16.5384 12.5039 16.4329C12.4512 16.1954 12.2401 16.0371 12.0026 16.0371ZM26.1451 6.48564L28.5462 16.9606C28.6781 17.5147 28.5462 18.0951 28.1768 18.5173L21.4221 26.9078C21.0791 27.3564 20.525 27.5938 19.971 27.5938H9.12663C8.54615 27.5938 8.01845 27.33 7.67544 26.9078L0.92082 18.5173C0.92082 18.5173 0.841672 18.4118 0.815287 18.359C0.551435 17.9368 0.445888 17.4355 0.551429 16.9342L2.95248 6.45926C3.08441 5.90517 3.45381 5.45662 3.95513 5.19277L13.7177 0.522586C13.9287 0.417045 14.1926 0.364276 14.4301 0.337891C14.7467 0.337891 15.0633 0.39066 15.3272 0.522586L25.0897 5.19277C25.591 5.43024 25.9604 5.90517 26.0923 6.45926L26.1451 6.48564ZM24.8522 16.8287C24.9314 16.512 24.6939 16.1954 24.3509 16.1163C24.2981 16.1163 24.219 16.0899 24.1926 16.0635C23.9815 16.0371 23.8232 16.0371 23.6385 16.0107C23.2427 15.9579 22.8997 15.9316 22.5831 15.826C22.4512 15.7732 22.372 15.6413 22.3192 15.5622L22.0818 15.483C22.2137 14.5859 22.1609 13.6888 21.9498 12.7653C21.7388 11.8418 21.3694 10.9711 20.8681 10.2323C20.9208 10.1796 21.0528 10.074 21.0791 10.0477C21.0791 9.94211 21.0791 9.83657 21.1847 9.70464C21.4221 9.49356 21.7124 9.30887 22.0554 9.09778C22.2137 8.99224 22.372 8.93947 22.5303 8.80754C22.5567 8.78116 22.6095 8.72839 22.6622 8.702C22.9525 8.49092 23.0053 8.09515 22.7942 7.83129C22.5831 7.56744 22.2137 7.56744 21.9235 7.77852C21.8707 7.80491 21.8179 7.85768 21.7915 7.88407C21.6332 8.01599 21.5277 8.14791 21.3958 8.27984C21.1055 8.57008 20.8681 8.80754 20.6042 8.99224C20.4987 9.04501 20.314 9.04502 20.2612 9.01863L20.0501 9.17694C18.7836 7.85767 17.0686 6.98696 15.1952 6.82865C15.1952 6.7495 15.1952 6.61757 15.1952 6.5648C15.1161 6.48565 15.0369 6.43288 15.0105 6.27457C15.0105 5.95794 15.0105 5.61493 15.0897 5.21915C15.1161 5.03446 15.1688 4.87615 15.1688 4.66507C15.1688 4.61229 15.1688 4.55952 15.1688 4.50675C15.1688 4.13736 14.905 3.84712 14.5884 3.84712C14.2717 3.84712 14.0079 4.13736 14.0079 4.50675C14.0079 4.55952 14.0079 4.61229 14.0079 4.66507C14.0079 4.87615 14.0607 5.03446 14.0871 5.21915C14.1398 5.61493 14.1662 5.95794 14.1398 6.27457C14.1398 6.38011 14.0343 6.51203 13.9551 6.5648V6.80227C13.5857 6.82866 13.2427 6.88142 12.8733 6.96058C11.343 7.30358 10.0501 8.09515 9.04747 9.15056C8.9947 9.09778 8.86277 9.01863 8.83639 8.99224C8.73085 8.99224 8.62531 9.04501 8.49339 8.96586C8.22953 8.78116 7.99207 8.54369 7.70183 8.25346C7.56991 8.12153 7.46436 7.9896 7.30605 7.85767C7.27966 7.83129 7.2269 7.77853 7.17413 7.75214C7.0422 7.6466 6.91027 7.59383 6.77834 7.59383C6.59365 7.59383 6.43533 7.64659 6.30341 7.8049C6.09233 8.06876 6.17148 8.43815 6.43533 8.67562C6.46172 8.70201 6.5145 8.75478 6.56727 8.78116C6.72558 8.91309 6.88389 8.96586 7.0422 9.0714C7.38521 9.28248 7.67544 9.46718 7.91291 9.67826C7.99206 9.7838 8.01845 9.94211 8.01845 10.0213L8.20315 10.1796C7.20051 11.6835 6.72557 13.5569 7.01581 15.4566L6.77834 15.5358C6.77834 15.5358 6.62004 15.7469 6.5145 15.7996C6.22426 15.9052 5.88125 15.9316 5.45908 15.9843C5.27439 15.9843 5.08969 15.9843 4.905 16.0371C4.85222 16.0371 4.79945 16.0371 4.74668 16.0635C4.40367 16.1426 4.19259 16.4593 4.24536 16.7759C4.32452 17.0925 4.64115 17.2772 5.01054 17.198C5.06331 17.198 5.11607 17.198 5.16884 17.1717C5.37993 17.1189 5.51185 17.0397 5.69655 16.9606C6.09233 16.8287 6.40895 16.6967 6.72557 16.6703C6.8575 16.6703 6.98943 16.7495 7.06858 16.7759L7.33243 16.7231C7.91291 18.5437 9.15302 20.0213 10.7097 20.9184L10.6042 21.1822C10.6042 21.1822 10.6834 21.4197 10.657 21.5252C10.5514 21.8155 10.3403 22.1321 10.1293 22.4751C10.0237 22.6334 9.91819 22.7653 9.81265 22.95C9.81265 23.0028 9.75987 23.0556 9.73349 23.1083C9.57517 23.425 9.68072 23.7943 9.97095 23.9263C10.2612 24.0582 10.6306 23.9263 10.7889 23.6097C10.7889 23.5569 10.8417 23.5041 10.8681 23.4513C10.9472 23.2666 10.9736 23.1083 11.0264 22.9236C11.1847 22.5279 11.2638 22.1321 11.4749 21.8682C11.5277 21.7891 11.6332 21.7627 11.7388 21.7363L11.8707 21.4988C13.2163 22.0265 14.7467 22.1585 16.2506 21.8155C16.5936 21.7363 16.9367 21.6308 17.2533 21.5252C17.2797 21.6044 17.3588 21.7099 17.3852 21.7627C17.4907 21.7891 17.5963 21.8155 17.6754 21.9474C17.8338 22.2112 17.9393 22.5543 18.0712 22.9236C18.124 23.1083 18.1504 23.2666 18.2295 23.4513C18.2295 23.5041 18.2823 23.5569 18.3087 23.6097C18.467 23.9263 18.8364 24.0846 19.1266 23.9527C19.4169 23.8207 19.5224 23.4513 19.3641 23.1347C19.3641 23.0819 19.3113 23.0292 19.2849 22.9764C19.1794 22.7917 19.0739 22.6598 18.9683 22.5015C18.7572 22.1585 18.5725 21.8682 18.4406 21.578C18.3878 21.4197 18.4406 21.3405 18.4934 21.235C18.4934 21.235 18.4142 21.0767 18.3878 20.9975C19.9973 20.0476 21.1847 18.5173 21.7652 16.7495C21.8443 16.7495 21.9762 16.7759 22.0026 16.8023C22.0818 16.7495 22.1609 16.6703 22.3192 16.6703C22.6359 16.7231 22.9525 16.8287 23.3483 16.9606C23.533 17.0397 23.6649 17.1189 23.876 17.1717C23.9287 17.1717 23.9815 17.1717 24.0343 17.198C24.3773 17.2772 24.7203 17.0925 24.7995 16.7759L24.8522 16.8287Z"
                                    fill="url(#paint0_linear_587_5548)"
                                  />
                                </svg>
                              ),
                              link: "https://www.lacework.com/platform/kubernetes/",
                              title: "Kubernetes Security (K8s)",
                              description:
                                "Find risks and threats in your K8s clusters",
                            },
                          ].map((menuItem) => {
                            const id = Math.floor(Math.random() * 100);

                            return (
                              <a
                                href={menuItem?.link}
                                // key={id + Math.random()}
                                className={`flex px-[16px] lg:px-0 lg:pb-0 ${
                                  data[0].title === "capabilities"
                                    ? "lg:pt-[28px]"
                                    : "lg:pt-[20px]"
                                }  svg-hover mega-menu-link primary-nav-child`}
                              >
                                {primaryLink && menuItem?.icon && (
                                  <div className="lg:mr-[12px] hidden lg:block">
                                    {menuItem.icon}
                                  </div>
                                )}
                                <div className="border-b lg:border-b-0 py-[1rem] lg:py-0 w-full">
                                  <p
                                    className="text-[16px] lg:text-[14px] flex items-center"
                                    style={{
                                      margin: "0",
                                      paddingBottom: "2px",
                                    }}
                                  >
                                    <style>{`
                                      .nav-item-arrow {
                                        display: none;
                                      }
        
                                      @media (min-width: 1024px) {
                                        .nav-item-arrow {
                                          display: inline;
                                          margin-top: -2px;
                                        } 
                                      }
                                    `}</style>
                                    <span>
                                      <span
                                        dangerouslySetInnerHTML={{
                                          __html: menuItem.title,
                                        }}
                                      />
                                      {/* <svg
                                        className="nav-item-arrow"
                                        width="12"
                                        height="11"
                                        viewBox="0 0 12 11"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M11.853 5.98808C11.853 5.98808 11.8648 5.96457 11.8707 5.95281C11.8942 5.91753 11.9177 5.87637 11.9294 5.83522C11.9353 5.81758 11.9412 5.79994 11.9471 5.7823C11.9588 5.74703 11.9706 5.71175 11.9824 5.67059C11.9941 5.6118 12 5.553 12 5.49421C12 5.43541 11.9941 5.37662 11.9824 5.31783C11.9765 5.28255 11.9588 5.24139 11.9471 5.20612C11.9412 5.18848 11.9353 5.17084 11.9294 5.1532C11.9118 5.11204 11.8883 5.07677 11.8707 5.03561C11.8648 5.02385 11.8589 5.01209 11.853 5.00033C11.8236 4.9533 11.7825 4.90626 11.7413 4.86511L7.89025 1.01993C7.54336 0.673043 6.98481 0.673043 6.6438 1.01993C6.30279 1.36682 6.29691 1.92537 6.6438 2.26638L7.26703 2.8896L8.99559 4.61817H0.881921C0.393925 4.61817 0 5.01209 0 5.50009C0 5.98808 0.393925 6.38201 0.881921 6.38201H8.99559L7.26703 8.11057L6.6438 8.7338C6.29691 9.08069 6.29691 9.63924 6.6438 9.98025C6.81431 10.1508 7.04361 10.2389 7.26703 10.2389C7.49045 10.2389 7.71975 10.1508 7.89025 9.98025L11.7472 6.12331C11.7883 6.08216 11.8236 6.03512 11.8589 5.98808H11.853Z"
                                          fill="#000538"
                                        />
                                      </svg> */}
                                    </span>
                                  </p>
                                  <p
                                    className="text-[14px] mega-menu-link-description hide-text-on-desktop"
                                    style={{ margin: "0" }}
                                  >
                                    {menuItem.description}
                                  </p>
                                </div>
                              </a>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            } else {
              return (
                <div
                  // key={Math.random() + menuIndex}
                  id={`menu-${menuIndex + 1}`}
                  className={`transition-all transform lg:transform-none absolute top-[80px] lg:top-0 lg:left-[220px] bg-[#fff] lg:px-16 h-full  w-full lg:w-[calc(100%-220px)] z-10 mega-menu-col-container  ${
                    active === menuIndex || (active === -1 && menuIndex === 0)
                      ? ""
                      : "hidden"
                  } ${
                    mobileActive !== menuIndex
                      ? "translate-x-[100%]"
                      : "translate-x-[0%]"
                  }`}
                >
                  <button
                    onClick={() => {
                      setMobileActive(-1);
                    }}
                    className="flex items-center gap-3 lg:hidden px-[16px] font-normal pt-[16px] pb-2"
                  >
                    <span>
                      <svg
                        width="10"
                        height="14"
                        viewBox="0 0 10 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M9.54324 1.645L3.92703 7L9.54324 12.355L7.81424 14L0.456757 7L7.81424 8.77371e-08L9.54324 1.645Z"
                          fill="#0738F1"
                        />
                      </svg>
                    </span>
                    <span>Back</span>
                  </button>
                  <p className="m-0 pt-[16px] uppercase text-[#0738F1] block lg:hidden tracking-[2px] px-[16px]">
                    <span className="border-b pb-[16px] lg:pb-0 block w-full">
                      {menu?.title?.toLowerCase()}
                    </span>
                  </p>
                  <div
                    className="lg:grid grid-cols-2 justify-center"
                    style={{ gap: "0px 25px", maxWidth: "750px" }}
                  >
                    <style>
                      {`
                      .mega-menu-link .mega-menu-link-description {
                        transition: color .2s ease;
                        color: #8289A1;
                      }
  
                      .mega-menu-link:hover .mega-menu-link-description {
                        color: var(--lacework-text);
                      }
                    `}
                    </style>
                    {menu.links.map((menuItem) => {
                      const id = Math.floor(Math.random() * 100);

                      return (
                        <a
                          href={menuItem?.link}
                          // key={id + Math.random()}
                          className="flex px-[16px] lg:px-0 lg:pb-0 lg:pt-[28px] svg-hover mega-menu-link primary-nav-child"
                        >
                          {primaryLink && menuItem?.icon && (
                            <div className="lg:mr-[12px] hidden lg:block">
                              {menuItem.icon}
                            </div>
                          )}
                          <div className="border-b lg:border-b-0 py-[1rem] lg:py-0 w-full">
                            <p
                              className="text-[16px] lg:text-[14px] flex items-center"
                              style={{ margin: "0", paddingBottom: "2px" }}
                            >
                              <style>{`
                                .nav-item-arrow {
                                  display: none;
                                }
  
                                @media (min-width: 1024px) {
                                  .nav-item-arrow {
                                    display: none;
                                    margin-top: -2px;
                                  } 
                                }
                              `}</style>
                              <span>
                                <span
                                  dangerouslySetInnerHTML={{
                                    __html: menuItem.title,
                                  }}
                                />
                                <svg
                                  className="nav-item-arrow"
                                  width="12"
                                  height="11"
                                  viewBox="0 0 12 11"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M11.853 5.98808C11.853 5.98808 11.8648 5.96457 11.8707 5.95281C11.8942 5.91753 11.9177 5.87637 11.9294 5.83522C11.9353 5.81758 11.9412 5.79994 11.9471 5.7823C11.9588 5.74703 11.9706 5.71175 11.9824 5.67059C11.9941 5.6118 12 5.553 12 5.49421C12 5.43541 11.9941 5.37662 11.9824 5.31783C11.9765 5.28255 11.9588 5.24139 11.9471 5.20612C11.9412 5.18848 11.9353 5.17084 11.9294 5.1532C11.9118 5.11204 11.8883 5.07677 11.8707 5.03561C11.8648 5.02385 11.8589 5.01209 11.853 5.00033C11.8236 4.9533 11.7825 4.90626 11.7413 4.86511L7.89025 1.01993C7.54336 0.673043 6.98481 0.673043 6.6438 1.01993C6.30279 1.36682 6.29691 1.92537 6.6438 2.26638L7.26703 2.8896L8.99559 4.61817H0.881921C0.393925 4.61817 0 5.01209 0 5.50009C0 5.98808 0.393925 6.38201 0.881921 6.38201H8.99559L7.26703 8.11057L6.6438 8.7338C6.29691 9.08069 6.29691 9.63924 6.6438 9.98025C6.81431 10.1508 7.04361 10.2389 7.26703 10.2389C7.49045 10.2389 7.71975 10.1508 7.89025 9.98025L11.7472 6.12331C11.7883 6.08216 11.8236 6.03512 11.8589 5.98808H11.853Z"
                                    fill="#000538"
                                  />
                                </svg>
                              </span>
                            </p>
                            <p
                              className="text-[14px] mega-menu-link-description"
                              style={{ margin: "0" }}
                            >
                              {menuItem.description}
                            </p>
                          </div>
                        </a>
                      );
                    })}
                  </div>
                </div>
              );
            }
          })}
      </div>
    </div>
  );
};

export const Nav = ({ dark }) => {
  const data = useStaticQuery(graphql`
    {
      wpPages {
        generalSettings {
          url
        }
        themeOption {
          megaMenu {
            ctaStyle
            ctaText
            ctaUrl
            topNav {
              label
              tabbedNavigation
              tabsLabel
              url
              megaMenuBox {
                linkText
                linkUrl
                newTab
                title
                videoLink
                videoProvider
                columnStyle
                listLinks {
                  link
                  newTab
                  label
                }
              }
              tabs {
                tabTitle
                tabDescription
                tabLinksLeftColumn {
                  linkUrl
                  linkText
                  linkEyebrow
                  linkDescription
                }
                tabLinksRightColumn {
                  linkDescription
                  linkEyebrow
                  linkText
                  linkUrl
                }
              }
              featuredDescription
              featuredLinkText
              featuredResourceDescription
              featuredResourceImage {
                altText
                mediaItemUrl
                sourceUrl
              }
              primaryLinkTitle
              primaryLinkDescription
            }
            contactOptions {
              contactLabel
              contactUrl
            }
            languageDropdownOptions {
              languageUrl
              language
              icon {
                altText
                mediaItemUrl
                sourceUrl
              }
            }
            companyDropdownOptions {
              pageName
              pageUrl
            }
          }
        }
      }
    }
  `);

  const navData = data?.wpPages;
  const boxShadow = "rgba(0, 0, 0, 0.25) 0px 15px 15px 0px";
  const [textColor, setTextColor] = useState(
    dark
      ? "text-[var(--lacework-text)] lg:!text-[#000]"
      : "text-[var(--lacework-text)] lg:!text-[#fff]"
  );
  const [iconColor, setIconColor] = useState("#fff");
  const [background, setBackgroundColor] = useState("rgba(255, 255, 255, 0)");
  const [shadow, setShadow] = useState("");
  const [activeMobile, setActiveMobile] = useState(false);
  const [searchActive, setSearchActive] = useState(false);

  const targetRef = useRef(null);
  const [eventTriggered, setEventTriggered] = useState(false);

  const baseLink = navData?.generalSettings?.url.replaceAll(
    `${process.env.GATSBY_WP_BASE_PAGES}`,
    `${process.env.GATSBY_LW_BASE_URL}`
  );

  // Search
  const [inputText, setInputText] = useState("");

  const handleEnterKeyPress = (event) => {
    if (event.key === "Enter") {
      const encodedText = encodeURIComponent(inputText);
      window.location.href = `${baseLink}/search/?s=${encodedText}`;
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      const scrollThreshold = window.innerHeight * 0.03; // 3% of the page's height
      const scrolledDistance = window.scrollY;

      if (!eventTriggered && scrolledDistance >= scrollThreshold) {
        // below
        setTextColor("text-[var(--lacework-text)] lg:!text-[#000]");
        setShadow(boxShadow);
        setBackgroundColor("rgba(255, 255, 255, 1)");
        setEventTriggered(true);
      } else if (eventTriggered && scrolledDistance < scrollThreshold) {
        // above
        setTextColor(
          dark
            ? "text-[var(--lacework-text)] lg:!text-[#000]"
            : "text-[var(--lacework-text)] lg:!text-[#fff]"
        );
        setShadow("");
        setBackgroundColor("rgba(255, 255, 255, 0)");
        setEventTriggered(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [eventTriggered]);

  return (
    <nav
      ref={targetRef}
      style={{
        boxShadow: shadow,
        backgroundColor: background,
        transition: "all 300ms ease",
      }}
      id="lw-header"
      className={`global-header fixed z-[10000] w-full transition ${
        eventTriggered ? "lg:translate-y-[-54px]" : "lg:translate-y-[0px]"
      }`}
    >
      <style>{`
        .mega-menu-col-container {
          height: calc(100vh - 80px);
          overflow: scroll;
        }

        @media (min-width: 1024px) {
          .mega-menu-col-container {
            height: 100%;
            overflow: visible;
          } 
        }
      `}</style>
      <ul
        style={{ maxWidth: "1240px" }}
        className="container m-auto hidden lg:flex justify-end lg:px-[30px] container-padding global-header__utility"
      >
        <li style={{ padding: "12px 0px", cursor: "pointer" }}>
          <div>
            <style>{`
              .search-input:focus-visible{
                outline:none!important;
              }
              .search-input::placeholder{
                color: white;
              }
            `}</style>
            <button
              onClick={() => {
                setSearchActive(!searchActive);
              }}
              className={`icon-search ${textColor}`}
              style={{
                fontSize: "16px",
                position: "relative",
                bottom: "0px",
                padding: "0px 8px",
                right: "8px",
              }}
            />
            {searchActive && (
              <input
                style={{
                  fontSize: "16px",
                  marginRight: "8px",
                  marginLeft: "8px",
                  borderBottom: "1px solid white",
                }}
                className={`leading-[21px] ${textColor} border-b search-input`}
                placeholder="Search"
                value={inputText}
                onChange={(event) => setInputText(event.target.value)}
                onKeyDown={handleEnterKeyPress}
              />
            )}
          </div>
        </li>
        <li
          className="group relative"
          style={{ padding: "12px 0px", cursor: "pointer" }}
        >
          <button
            style={{
              height: "30px",
              verticalAlign: "middle",
              padding: "0px 10px",
            }}
            className="font-medium flex items-center nav-trigger group-hover:opacity-50 transition"
          >
            <span
              className={`leading-[21px] ${textColor}`}
              style={{ fontSize: "16px", marginRight: "8px" }}
            >
              Company
            </span>
            <span className="ml-2 transform group-hover:rotate-180 flex">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="11"
                height="7"
                viewBox="0 0 11 7"
                fill="none"
              >
                <path
                  d="M1.20725 0.165526L5.13721 4.28719L9.06718 0.165527L10.2744 1.43442L5.13721 6.83398L4.72045e-07 1.43442L1.20725 0.165526Z"
                  fill={
                    textColor === "text-[var(--lacework-text)] lg:!text-[#fff]"
                      ? "#fff"
                      : "#000538"
                  }
                />
              </svg>
            </span>
          </button>
          <span
            className="absolute hidden lg:group-hover:block"
            style={{
              bottom: "-9px",
              left: "50%",
              transform: "translateX(-70%)",
              pointerEvents: "none",
              zIndex: 20,
            }}
          >
            <svg
              width="27"
              height="12"
              viewBox="0 0 27 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.566 1.63102L0 11.3848H27L15.434 1.63102C14.3168 0.688829 12.6832 0.688831 11.566 1.63102Z"
                fill="white"
              />
              <path
                opacity="0.5"
                d="M11.566 1.63102L0 11.3848H27L15.434 1.63102C14.3168 0.688829 12.6832 0.688831 11.566 1.63102Z"
                fill="white"
              />
            </svg>
          </span>
          <DropDown
            data={navData?.themeOption?.megaMenu?.companyDropdownOptions?.map(
              (item) => {
                return {
                  title: item.pageName,
                  href: item.pageUrl,
                };
              }
            )}
          />
        </li>
        <li
          className="group relative"
          style={{ padding: "12px 0px", cursor: "pointer" }}
        >
          <a
            style={{ height: "30px", verticalAlign: "middle" }}
            href={navData?.themeOption?.megaMenu?.contactOptions?.contactUrl}
            className="font-medium flex items-center px-3 nav-trigger group-hover:opacity-50 transition primary-nav-parent"
          >
            <span
              className={`leading-[21px]`}
              style={{
                fontSize: "16px",
                color: eventTriggered || dark ? "var(--lacework-text)" : "#fff",
              }}
            >
              {navData?.themeOption?.megaMenu?.contactOptions?.contactLabel}
            </span>
          </a>
        </li>
        <li
          className="group relative"
          style={{ padding: "12px 0px", cursor: "pointer" }}
        >
          <a
            style={{ height: "30px", verticalAlign: "middle" }}
            href="https://login.lacework.net/"
            target="_blank"
            className="font-medium flex items-center px-3 nav-trigger group-hover:opacity-50 transition primary-nav-parent"
          >
            <span
              className={`leading-[21px]`}
              style={{
                fontSize: "16px",
                color: eventTriggered || dark ? "var(--lacework-text)" : "#fff",
              }}
            >
              Login
            </span>
          </a>
        </li>
        <li
          className="group relative"
          style={{ padding: "12px 0px", cursor: "pointer" }}
        >
          <button
            className="font-medium flex items-center group-hover:opacity-50"
            style={{ height: "30px", paddingLeft: "10px" }}
          >
            <span
              className={`icon-language ${textColor}`}
              style={{ marginRight: "8px", pointerEvents: "none" }}
            />
            <span
              className="ml-2 transform group-hover:rotate-180 flex"
              style={{ pointerEvents: "none" }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="11"
                height="7"
                viewBox="0 0 11 7"
                fill="none"
                style={{ pointerEvents: "none" }}
              >
                <path
                  d="M1.20725 0.165526L5.13721 4.28719L9.06718 0.165527L10.2744 1.43442L5.13721 6.83398L4.72045e-07 1.43442L1.20725 0.165526Z"
                  fill={
                    textColor === "text-[var(--lacework-text)] lg:!text-[#fff]"
                      ? "#fff"
                      : "#000538"
                  }
                />
              </svg>
            </span>
          </button>
          <span
            className="absolute hidden lg:group-hover:block"
            style={{
              bottom: "-8px",
              left: "33%",
              transform: "translateX(-50%)",
              pointerEvents: "none",
              zIndex: 20,
            }}
          >
            <svg
              width="27"
              height="12"
              viewBox="0 0 27 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.566 1.63102L0 11.3848H27L15.434 1.63102C14.3168 0.688829 12.6832 0.688831 11.566 1.63102Z"
                fill="white"
              />
              <path
                opacity="0.5"
                d="M11.566 1.63102L0 11.3848H27L15.434 1.63102C14.3168 0.688829 12.6832 0.688831 11.566 1.63102Z"
                fill="white"
              />
            </svg>
          </span>
          <DropDown
            data={navData?.themeOption?.megaMenu?.languageDropdownOptions.map(
              (item) => {
                return {
                  title: item?.language,
                  href: item?.languageUrl,
                  icon: (
                    <img
                      width="20"
                      height="20"
                      src={item?.icon?.mediaItemUrl}
                    ></img>
                  ),
                };
              }
            )}
          />
        </li>
      </ul>
      <ul
        style={{ maxWidth: "1240px" }}
        className={`container m-auto flex flex-col lg:flex-row relative bg-[#fff] lg:bg-transparent container-padding`}
      >
        <style>{`
          .nav-list-link {
            padding-top: 0px;
            padding-bottom: 0px;
          }

          @media (min-width: 1024px) {
            .nav-list-link {
              padding-top: 10px;  
              padding-bottom: 16px;
            }
          }

          .nav-list-items {
            padding-top: 10px;
            padding-bottom: 10px;
          }

          @media (min-width: 1024px) {
            .nav-list-items {
              padding-top: 10px;  
              padding-bottom: 16px;
            }
          }

          .nav-title {
            padding-bottom: 10px;
          }

          @media (min-width: 1024px) {
            .nav-title {
              padding-bottom: 0px;
            } 
          }

          .mobile-nav-scroll {
            height: calc(100vh - 200px);
            overflow: scroll;
            box-shadow: ${boxShadow};
          }

          @media (min-width: 1024px) {
            .mobile-nav-scroll {
              height: auto;
              overflow: visible;
              box-shadow: none;
            } 
          }
        `}</style>
        <li
          className={`nav-list-items flex h-[80px] lg:h-auto ${
            eventTriggered && !activeMobile ? "bg-transparent" : "bg-[#000538]"
          }  lg:bg-transparent`}
        >
          <a
            href={baseLink + "/"}
            className="text-white font-bold text-lg flex lg:mr-[20px] logo"
          >
            <svg
              className="w-[160px]"
              id="Primary_Lockup_Light_Registered_"
              data-name="Primary Lockup (Light Registered)"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 1900 315.41"
            >
              <defs>
                <style>
                  {`.cls-1{fill: url(#Lacework_Coral_Gradient_RGB);}.cls-2{fill: url(#Lacework_Blue_Gradient_RGB);}.cls-3{fill: url(#Lacework_Teal_Gradient_RGB);}`}
                </style>
                <linearGradient
                  id="Lacework_Coral_Gradient_RGB"
                  x1="-37.72"
                  y1="8.1"
                  x2="33.69"
                  y2="131.8"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop offset="0" stopColor="#01023b"></stop>
                  <stop offset="1" stopColor="#ff646c"></stop>
                </linearGradient>
                <linearGradient
                  id="Lacework_Blue_Gradient_RGB"
                  x1="309.12"
                  y1="36.3"
                  x2="241.14"
                  y2="154.05"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop offset="0" stopColor="#01023b"></stop>
                  <stop offset="0.24" stopColor="#071573"></stop>
                  <stop offset="0.49" stopColor="#0d27aa"></stop>
                  <stop offset="0.72" stopColor="#1135d2"></stop>
                  <stop offset="0.89" stopColor="#143dea"></stop>
                  <stop offset="1" stopColor="#1540f3"></stop>
                </linearGradient>
                <linearGradient
                  id="Lacework_Teal_Gradient_RGB"
                  y1="27.57"
                  x2="287.68"
                  y2="27.57"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop offset="0.2" stopColor="#00f8f8"></stop>
                  <stop offset="0.3" stopColor="#00f4f8"></stop>
                  <stop offset="0.4" stopColor="#02e7f8"></stop>
                  <stop offset="0.51" stopColor="#04d3f7"></stop>
                  <stop offset="0.61" stopColor="#08b6f6"></stop>
                  <stop offset="0.72" stopColor="#0c90f5"></stop>
                  <stop offset="0.83" stopColor="#1163f4"></stop>
                  <stop offset="0.9" stopColor="#1540f3"></stop>
                </linearGradient>
              </defs>
              <g
                id="Primary_Lockup_Light_Registered_2"
                data-name="Primary Lockup (Light Registered)"
              >
                <g id="Shield">
                  <path
                    className="cls-1"
                    d="M143.84,315.41S0,284.06,0,143.45V0L57.16,55.15v88.3c0,83.6,86.68,112,86.68,112Z"
                  ></path>
                  <path
                    className="cls-2"
                    d="M143.84,315.41s143.84-31.35,143.84-172V0L230.53,55.15v88.3c0,83.6-86.69,112-86.69,112Z"
                  ></path>
                  <polygon
                    className="cls-3"
                    points="230.53 55.15 57.16 55.15 0 0 287.68 0 230.53 55.15"
                  ></polygon>
                </g>
                <g id="Wordmark">
                  <g id="Wordmark-2" data-name="Wordmark">
                    <style>{`
                      .resource-logo-colors {
                        fill: #fff;
                      }
                      .resource-logo-colors.triggered {
                        fill: #000;
                      }
                      @media (min-width: 1024px) {
                        .resource-logo-colors {
                          fill: #000;
                        } 
                      }
                    `}</style>
                    <path
                      className={`${
                        dark
                          ? `resource-logo-colors ${
                              eventTriggered ? "triggered" : ""
                            }`
                          : eventTriggered && !activeMobile
                          ? "fill-[#000]"
                          : "fill-[#fff]"
                      }`}
                      d="M853.54,178.84l-.1.71c-4.55,32.29-26.12,50.08-60.75,50.08-41.86,0-68.9-29.57-68.9-75.34S750.83,79,792.69,79c33,0,54.24,16.83,58.4,46.16l.1.71H883l-.1-.92c-2.25-20.26-11.17-38.6-25.13-51.64-16.06-15-38.56-23-65.08-23-60.13,0-100.53,41.79-100.53,104s40.4,104,100.53,104c38.73,0,86.18-20.56,92.42-78.51l.1-.92Z"
                    ></path>
                    <polygon
                      className={`${
                        dark
                          ? `resource-logo-colors ${
                              eventTriggered ? "triggered" : ""
                            }`
                          : eventTriggered && !activeMobile
                          ? "fill-[#000]"
                          : "fill-[#fff]"
                      }`}
                      points="942.91 226.46 942.91 165.43 1030.72 165.43 1030.72 136.8 942.91 136.8 942.91 83.89 1040.18 83.89 1040.18 55.24 911.55 55.24 911.55 255.1 1041.53 255.1 1041.53 226.46 942.91 226.46"
                    ></polygon>
                    <polygon
                      className={`${
                        dark
                          ? `resource-logo-colors ${
                              eventTriggered ? "triggered" : ""
                            }`
                          : eventTriggered && !activeMobile
                          ? "fill-[#000]"
                          : "fill-[#fff]"
                      }`}
                      points="416.43 55.15 416.43 226.36 506.94 226.36 506.94 255 385.07 255 385.07 55.15 416.43 55.15"
                    ></polygon>
                    <polygon
                      className={`${
                        dark
                          ? `resource-logo-colors ${
                              eventTriggered ? "triggered" : ""
                            }`
                          : eventTriggered && !activeMobile
                          ? "fill-[#000]"
                          : "fill-[#fff]"
                      }`}
                      points="1270.53 55.24 1239.13 223.52 1207.45 55.24 1157.6 55.24 1125.92 223.52 1094.54 55.24 1063.9 55.24 1063.95 63.85 1100.59 255.1 1150.72 255.1 1182.47 85.78 1214.34 255.1 1264.47 255.1 1301.16 63.34 1301.16 55.24 1270.53 55.24"
                    ></polygon>
                    <path
                      className={`${
                        dark
                          ? `resource-logo-colors ${
                              eventTriggered ? "triggered" : ""
                            }`
                          : eventTriggered && !activeMobile
                          ? "fill-[#000]"
                          : "fill-[#fff]"
                      }`}
                      d="M1413.13,50.31c-61.74,0-103.22,41.79-103.22,104s41.48,104,103.22,104,103.22-41.79,103.22-104S1474.87,50.31,1413.13,50.31Zm71.59,104c0,45.22-28.77,75.61-71.59,75.61-44.15,0-71.59-29-71.59-75.61s27.44-75.61,71.59-75.61C1456,78.68,1484.72,109.07,1484.72,154.29Z"
                    ></path>
                    <polygon
                      className={`${
                        dark
                          ? `resource-logo-colors ${
                              eventTriggered ? "triggered" : ""
                            }`
                          : eventTriggered && !activeMobile
                          ? "fill-[#000]"
                          : "fill-[#fff]"
                      }`}
                      points="1857.25 75.83 1857.25 55.24 1833.35 55.24 1740 143.48 1740 55.24 1708.65 55.24 1708.65 255.1 1740 255.1 1740 184.84 1763.32 163.2 1835.67 255.1 1857.25 255.1 1857.25 233.9 1785.69 142.34 1857.25 75.83"
                    ></polygon>
                    <path
                      className={`${
                        dark
                          ? `resource-logo-colors ${
                              eventTriggered ? "triggered" : ""
                            }`
                          : eventTriggered && !activeMobile
                          ? "fill-[#000]"
                          : "fill-[#fff]"
                      }`}
                      d="M1640.2,171.9c27.73-6.62,43.65-27.3,43.75-56.89.11-37.21-24.07-59.49-64.68-59.62l-80-.24L1538.67,255l31.36.1.25-81,35.32.12L1658,255.1h25.63l.06-21.2S1640.13,171.92,1640.2,171.9Zm-69.65-88.72,45.93.14c24.7.08,36.17,9.89,36.11,30.89S1641,145,1616.3,144.88l-45.94-.14Z"
                    ></path>
                    <path
                      className={`${
                        dark
                          ? `resource-logo-colors ${
                              eventTriggered ? "triggered" : ""
                            }`
                          : eventTriggered && !activeMobile
                          ? "fill-[#000]"
                          : "fill-[#fff]"
                      }`}
                      d="M629.82,55.15H585.27L528.81,240.24V255h28.61l17.84-59.95h64.57L657.67,255h28.68V240.24Zm-46,110.48,23.56-79.88,23.78,79.88Z"
                    ></path>
                  </g>
                  <g id="Registered">
                    <path
                      className="cls-4"
                      d="M1889,255.1A11.08,11.08,0,1,1,1900,244,11.08,11.08,0,0,1,1889,255.1Zm0-21.21A10.12,10.12,0,1,0,1899.06,244,10.14,10.14,0,0,0,1889,233.89Zm-5,3.52h6.5a4,4,0,0,1,3.87,4,3.79,3.79,0,0,1-2.21,3.55c-.09,0-.09.16-.06.22l2.39,5.28a.12.12,0,0,1-.12.19h-1.48a.35.35,0,0,1-.32-.16l-2.17-5a.21.21,0,0,0-.22-.12h-4.46a.08.08,0,0,0-.09.09v5a.15.15,0,0,1-.16.16H1884a.15.15,0,0,1-.16-.16V237.56A.14.14,0,0,1,1884,237.41Zm1.79,1.6a.15.15,0,0,0-.16.16v4.46a.15.15,0,0,0,.16.16h4.55a2.38,2.38,0,0,0,2.23-2.36,2.44,2.44,0,0,0-2.29-2.42Z"
                    ></path>
                  </g>
                </g>
              </g>
            </svg>
          </a>
          <button
            className="ml-auto block lg:hidden"
            style={{ padding: "10px 16px" }}
            onClick={() => {
              // if (document) {
              //   document.body.style.overflow = !activeMobile ? "hidden" : "";
              //   document.body.style.maxHeight = !activeMobile ? "100vh" : "";
              // }
              setActiveMobile(!activeMobile);
            }}
          >
            {!activeMobile && (
              <svg
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  opacity={eventTriggered && !activeMobile ? "0.05" : "0.2"}
                  width="40"
                  height="40"
                  rx="10"
                  fill={eventTriggered && !activeMobile ? "black" : "white"}
                />
                <rect
                  x="10"
                  y="12"
                  width="20"
                  height="2.22222"
                  rx="1.11111"
                  fill={eventTriggered && !activeMobile ? "black" : "white"}
                />
                <rect
                  x="10"
                  y="19.2227"
                  width="20"
                  height="2.22222"
                  rx="1.11111"
                  fill={eventTriggered && !activeMobile ? "black" : "white"}
                />
                <rect
                  x="10"
                  y="26"
                  width="20"
                  height="2.22222"
                  rx="1.11111"
                  fill={eventTriggered && !activeMobile ? "black" : "white"}
                />
              </svg>
            )}
            {activeMobile && (
              <svg
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  opacity="0.2"
                  width="40"
                  height="40"
                  rx="10"
                  fill="white"
                />
                <rect
                  x="10.5742"
                  y="27.5127"
                  width="24"
                  height="2.66667"
                  rx="1.33333"
                  transform="rotate(-45 10.5742 27.5127)"
                  fill="white"
                />
                <rect
                  x="12.457"
                  y="10.542"
                  width="24"
                  height="2.66667"
                  rx="1.33333"
                  transform="rotate(45 12.457 10.542)"
                  fill="white"
                />
              </svg>
            )}
          </button>
        </li>
        <ul
          className={`lg:flex flex-col lg:flex-row w-full mobile-nav-scroll global-header__nav ${
            !activeMobile ? "hidden" : "block"
          }`}
        >
          <li
            style={{ alignItems: "center", padding: "16px 16px 0px 16px" }}
            className="nav-list-link group flex flex-row lg:hidden py-[1rem] lg:py-0"
          >
            <style>{`
              .mobile-search-input:focus-visible{
                outline:none!important;
              }
              .mobile-search-input::placeholder{
                color: #0003585c;
              }
            `}</style>
            <span
              style={{
                position: "absolute",
                right: "0",
                marginRight: "32px",
                pointerEvents: "none",
              }}
              className={`icon-search ${textColor}`}
            ></span>
            <input
              style={{
                background: "#DBE2FF",
                fontSize: "16px",
                borderBottom: "1px solid white",
                borderRadius: "10px",
                padding: "10px 14px",
              }}
              className={`leading-[21px] ${textColor} border-b mobile-search-input w-full`}
              placeholder="Search"
              value={inputText}
              onChange={(event) => setInputText(event.target.value)}
              onKeyDown={handleEnterKeyPress}
            />
          </li>
          <li className="nav-list-link group flex flex-col lg:flex-row border-b lg:border-b-0 py-[1rem] lg:py-0">
            <style>
              {`
              .padding-top {
                padding-top: 14px;
                padding-bottom: 14px;
              }
              @media (min-width: 1024px) {
                .padding-top {
                  padding-top: 0px;
                  padding-bottom: 0px;
                }
              }
            `}
            </style>
            <a
              href={navData?.themeOption?.megaMenu?.topNav?.[0].url}
              className={`font-medium text-[18px] lg:normal-case lg:text-[16px] flex lg:items-center lg:relative ${textColor} px-[16px] padding-top primary-nav-parent`}
            >
              <span
                className={`transition lg:group-hover:opacity-50 py-[1rem] ${textColor}`}
              >
                {navData?.themeOption?.megaMenu?.topNav?.[0].label}
              </span>
            </a>
          </li>
          <li className="nav-list-items group flex flex-col lg:flex-row border-b lg:border-b-0 pt-[16px] pb-[16px]">
            <a
              href="/"
              className={`font-medium text-[14px] uppercase lg:normal-case lg:text-[16px] flex lg:items-center lg:relative ${textColor} pointer-events-none lg:pointer-events-auto px-[16px] lg:pt-0 lg:pb-[0px]`}
            >
              <span className="lg:group-hover:opacity-50 lg:text-inherit nav-title">
                {navData?.themeOption?.megaMenu?.topNav?.[1].label}
              </span>
              <span
                className="absolute hidden lg:group-hover:block"
                style={{
                  bottom: "-10px",
                  left: "50%",
                  transform: "translateX(-50%)",
                  pointerEvents: "none",
                  zIndex: "20",
                }}
              >
                <svg
                  width="27"
                  height="12"
                  viewBox="0 0 27 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M11.566 1.63102L0 11.3848H27L15.434 1.63102C14.3168 0.688829 12.6832 0.688831 11.566 1.63102Z"
                    fill="white"
                  />
                  <path
                    opacity="0.5"
                    d="M11.566 1.63102L0 11.3848H27L15.434 1.63102C14.3168 0.688829 12.6832 0.688831 11.566 1.63102Z"
                    fill="white"
                  />
                </svg>
              </span>
            </a>
            <MegaMenuA
              primaryLink="platform"
              primaryLinkData={{
                title:
                  navData?.themeOption?.megaMenu?.topNav?.[1]?.primaryLinkTitle,
                description:
                  navData?.themeOption?.megaMenu?.topNav?.[1]
                    ?.primaryLinkDescription,
                link: navData?.themeOption?.megaMenu?.topNav?.[1]?.url,
              }}
              data={[
                {
                  title:
                    navData?.themeOption?.megaMenu?.topNav?.[1]?.tabs?.[0]
                      ?.tabTitle,
                  links: [
                    {
                      title:
                        navData?.themeOption?.megaMenu?.topNav?.[1]?.tabs?.[0]
                          ?.tabLinksLeftColumn[0]?.linkText,
                      // "Cloud-Native Application Protection Platform (CNAPP)",
                      description:
                        navData?.themeOption?.megaMenu?.topNav?.[1]?.tabs?.[0]
                          ?.tabLinksLeftColumn[0]?.linkDescription,
                      link: navData?.themeOption?.megaMenu?.topNav?.[1]
                        ?.tabs?.[0]?.tabLinksLeftColumn[0]?.linkUrl,
                      icon: (
                        <svg
                          style={{ maxWidth: "25px", maxHeight: "25px" }}
                          className="no-hover"
                          width="30"
                          height="21"
                          viewBox="0 0 30 21"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M19.6041 9.7627V14.6967C19.6041 19.3669 24.4326 20.95 24.4326 20.95C24.4326 20.95 29.2611 19.3669 29.2611 14.6967V9.7627H19.6305H19.6041Z"
                            fill="#47A2E4"
                          />
                          <path
                            d="M20.686 3.79947C19.1029 1.4248 16.4644 0 13.6148 0C9.89446 0 6.67546 2.45383 5.5409 5.91029C2.40106 6.54353 0 9.31398 0 12.6385C0 15.9631 2.18997 18.6016 5.14512 19.2876C5.67282 19.4723 6.22691 19.5514 6.80739 19.5514H15.3034C16.2797 19.5514 17.0976 18.7599 17.0976 17.7573C17.0976 16.7546 16.3061 15.9631 15.3034 15.9631H6.80739C6.64908 15.9631 6.46438 15.9367 6.12137 15.8311C4.61741 15.4881 3.56201 14.1689 3.56201 12.6121C3.56201 10.7916 5.03958 9.31398 6.86016 9.31398C6.86016 9.31398 6.86016 9.31398 6.88654 9.31398C6.88654 9.31398 6.91293 9.31398 6.93931 9.31398C7.83641 9.31398 8.5752 8.65435 8.70712 7.78364C9.05013 5.38259 11.1609 3.562 13.5884 3.562C15.2507 3.562 16.781 4.37995 17.7045 5.77836C18.2586 6.59631 19.3668 6.83377 20.1847 6.27968C21.0026 5.72559 21.2401 4.61741 20.686 3.79947Z"
                            fill="url(#paint0_linear_587_5530)"
                          />
                          <defs>
                            <linearGradient
                              id="paint0_linear_587_5530"
                              x1="3.08707"
                              y1="19.6042"
                              x2="20.3166"
                              y2="2.37467"
                              gradientUnits="userSpaceOnUse"
                            >
                              <stop stop-color="#64D3DD" />
                              <stop offset="1" stop-color="#3381E8" />
                            </linearGradient>
                          </defs>
                        </svg>
                      ),
                    },
                    {
                      title:
                        navData?.themeOption?.megaMenu?.topNav?.[1]?.tabs?.[0]
                          ?.tabLinksRightColumn[0]?.linkText,
                      // "Cloud-Native Application Protection Platform (CNAPP)",
                      description:
                        navData?.themeOption?.megaMenu?.topNav?.[1]?.tabs?.[0]
                          ?.tabLinksRightColumn[0]?.linkDescription,
                      link: navData?.themeOption?.megaMenu?.topNav?.[1]
                        ?.tabs?.[0]?.tabLinksRightColumn[0]?.linkUrl,
                      icon: (
                        <svg
                          style={{ maxWidth: "25px", maxHeight: "25px" }}
                          className="no-hover"
                          width="32"
                          height="25"
                          viewBox="0 0 32 25"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M0.0263808 12.6385C0.0263808 9.31398 2.40106 6.51715 5.56728 5.91029C6.67546 2.48021 9.92084 0 13.6148 0C16.4644 0 19.1029 1.4248 20.686 3.79947C21.2401 4.61741 21.0026 5.72559 20.1847 6.27968C19.3667 6.83377 18.2586 6.59631 17.7045 5.77836C16.781 4.40633 15.2507 3.562 13.5884 3.562C11.1609 3.562 9.05013 5.38258 8.70712 7.78364C8.57519 8.65435 7.8364 9.31398 6.93931 9.31398C6.91292 9.31398 6.88654 9.31398 6.86015 9.31398C5.03957 9.31398 3.562 10.7916 3.562 12.6121C3.562 14.1425 4.61741 15.4881 6.12137 15.8311C6.46438 15.9367 6.62269 15.9631 6.80738 15.9631H11.2929C12.2691 15.9631 13.0871 16.7546 13.0871 17.7573C13.0871 18.7599 12.2955 19.5514 11.2929 19.5514H6.80738C6.25329 19.5514 5.69921 19.4723 5.14512 19.2876C2.18998 18.6016 0 15.8575 0 12.6385H0.0263808Z"
                            fill="url(#paint0_linear_587_5551)"
                          />
                          <path
                            d="M30.5277 21.1348L27.8628 18.4699C28.3377 17.5728 28.6015 16.5702 28.6015 15.4884C28.6015 11.8472 25.6464 8.89209 22.0052 8.89209C18.3641 8.89209 15.4089 11.8472 15.4089 15.4884C15.4089 19.1296 18.3641 22.0847 22.0052 22.0847C23.2717 22.0847 24.4327 21.7153 25.4353 21.1084L27.9947 23.6678C28.3377 24.0108 28.8126 24.1955 29.2612 24.1955C29.7097 24.1955 30.1847 24.0108 30.5277 23.6678C31.2137 22.9818 31.2137 21.8472 30.5277 21.1348ZM22.0052 18.5227C20.343 18.5227 18.9709 17.1507 18.9709 15.4884C18.9709 13.8261 20.343 12.4541 22.0052 12.4541C23.6675 12.4541 25.0395 13.8261 25.0395 15.4884C25.0395 17.1507 23.6675 18.5227 22.0052 18.5227Z"
                            fill="#47A2E4"
                          />
                          <defs>
                            <linearGradient
                              id="paint0_linear_587_5551"
                              x1="1.29288"
                              y1="19.4195"
                              x2="22.0317"
                              y2="-1.31926"
                              gradientUnits="userSpaceOnUse"
                            >
                              <stop stop-color="#64D3DD" />
                              <stop offset="1" stop-color="#3381E8" />
                            </linearGradient>
                          </defs>
                        </svg>
                      ),
                    },
                    {
                      title:
                        navData?.themeOption?.megaMenu?.topNav?.[1]?.tabs?.[0]
                          ?.tabLinksLeftColumn[1]?.linkText,
                      // "Cloud-Native Application Protection Platform (CNAPP)",
                      description:
                        navData?.themeOption?.megaMenu?.topNav?.[1]?.tabs?.[0]
                          ?.tabLinksLeftColumn[1]?.linkDescription,
                      link: navData?.themeOption?.megaMenu?.topNav?.[1]
                        ?.tabs?.[0]?.tabLinksLeftColumn[1]?.linkUrl,
                      icon: (
                        <svg
                          style={{ maxWidth: "25px", maxHeight: "25px" }}
                          className="no-hover"
                          width="23"
                          height="30"
                          viewBox="0 0 23 30"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M1.73347 29.8681H20.7044C21.5752 29.8681 22.2612 29.1557 22.2612 28.3113V14.9604C22.2612 14.0897 21.5488 13.4037 20.7044 13.4037H19.649V8.41688C19.649 3.77308 15.876 0 11.2322 0C6.58835 0 2.81526 3.77308 2.81526 8.41688V13.4037H1.75985C0.889141 13.4037 0.203125 14.1161 0.203125 14.9604V28.3113C0.203125 29.1821 0.915526 29.8681 1.75985 29.8681H1.73347ZM19.1477 26.7282H3.31658V16.5171H19.1477V26.7282ZM5.9551 8.3905C5.9551 5.48812 8.32978 3.11345 11.2322 3.11345C14.1345 3.11345 16.5092 5.48812 16.5092 8.3905V13.3773H5.92872V8.3905H5.9551Z"
                            fill="url(#paint0_linear_587_5533)"
                          />
                          <path
                            d="M9.43787 21.6091C9.43787 20.6329 10.2294 19.8149 11.2321 19.8149C12.2347 19.8149 13.0263 20.6065 13.0263 21.6091C13.0263 22.6118 12.2347 23.4033 11.2321 23.4033C10.2294 23.4033 9.43787 22.6118 9.43787 21.6091Z"
                            fill="#4EAEE2"
                          />
                          <defs>
                            <linearGradient
                              id="paint0_linear_587_5533"
                              x1="0.361437"
                              y1="29.1029"
                              x2="22.1029"
                              y2="7.36147"
                              gradientUnits="userSpaceOnUse"
                            >
                              <stop stop-color="#64D3DD" />
                              <stop offset="1" stop-color="#3381E8" />
                            </linearGradient>
                          </defs>
                        </svg>
                      ),
                    },
                    {
                      title:
                        navData?.themeOption?.megaMenu?.topNav?.[1]?.tabs?.[0]
                          ?.tabLinksRightColumn[1]?.linkText,
                      // "Cloud-Native Application Protection Platform (CNAPP)",
                      description:
                        navData?.themeOption?.megaMenu?.topNav?.[1]?.tabs?.[0]
                          ?.tabLinksRightColumn[1]?.linkDescription,
                      link: navData?.themeOption?.megaMenu?.topNav?.[1]
                        ?.tabs?.[0]?.tabLinksRightColumn[1]?.linkUrl,
                      icon: (
                        <svg
                          style={{ maxWidth: "25px", maxHeight: "25px" }}
                          className="no-hover"
                          width="25"
                          height="28"
                          viewBox="0 0 25 28"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M0.108182 1.82058V12.4538C0.108182 21.4512 7.70713 26.3061 11.7177 27.6253C11.9024 27.6781 12.0871 27.7045 12.2718 27.7045C12.4565 27.7045 12.6412 27.6781 12.8259 27.6253C16.8364 26.3061 24.4354 21.4248 24.4354 12.4274V1.7942C24.4354 0.817943 23.6438 0 22.6412 0H1.84962C0.873363 0 0.0554199 0.791557 0.0554199 1.7942L0.108182 1.82058ZM3.67019 3.61477H20.8997V12.4538C20.8997 19.9208 14.3034 23.219 12.2982 24.0369C10.2929 23.219 3.69657 19.9208 3.69657 12.4538V3.61477H3.67019Z"
                            fill="url(#paint0_linear_587_5545)"
                          />
                          <path
                            d="M9.55405 17.3615L5.99205 13.7731C5.30604 13.0607 5.30604 11.9525 5.99205 11.2401C6.70445 10.5541 7.83901 10.5541 8.52503 11.2401L10.8469 13.5884L16.7836 7.67809C17.4696 6.99207 18.6042 6.99207 19.3166 7.67809C20.0026 8.39049 20.0026 9.49866 19.3166 10.2111L12.1662 17.3351C11.9815 17.5198 11.744 17.6517 11.5066 17.7309C11.2955 17.81 11.058 17.8628 10.8205 17.8628C10.372 17.8628 9.89706 17.6781 9.55405 17.3351V17.3615Z"
                            fill="#4EAEE2"
                          />
                          <defs>
                            <linearGradient
                              id="paint0_linear_587_5545"
                              x1="1.82323"
                              y1="20.343"
                              x2="22.7731"
                              y2="-0.606859"
                              gradientUnits="userSpaceOnUse"
                            >
                              <stop stop-color="#64D3DD" />
                              <stop offset="1" stop-color="#3381E8" />
                            </linearGradient>
                          </defs>
                        </svg>
                      ),
                    },
                    {
                      title:
                        navData?.themeOption?.megaMenu?.topNav?.[1]?.tabs?.[0]
                          ?.tabLinksLeftColumn[2]?.linkText,
                      // "Cloud-Native Application Protection Platform (CNAPP)",
                      description:
                        navData?.themeOption?.megaMenu?.topNav?.[1]?.tabs?.[0]
                          ?.tabLinksLeftColumn[2]?.linkDescription,
                      link: navData?.themeOption?.megaMenu?.topNav?.[1]
                        ?.tabs?.[0]?.tabLinksLeftColumn[2]?.linkUrl,
                      icon: (
                        <svg
                          style={{ maxWidth: "25px", maxHeight: "25px" }}
                          className="no-hover"
                          width="31"
                          height="17"
                          viewBox="0 0 31 17"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M6.43622 2.33063C6.92402 2.33063 7.41183 2.52034 7.79124 2.89974C8.52295 3.63145 8.52295 4.85097 7.79124 5.58268L4.81019 8.56373L7.79124 11.5448C8.17064 11.9242 8.36035 12.412 8.36035 12.8998C8.36035 13.3876 8.17064 13.8754 7.79124 14.2548C7.05953 15.0136 5.84001 15.0136 5.1083 14.2548L0.772233 9.89165C0.392828 9.51224 0.203125 9.02444 0.203125 8.53663C0.203125 8.04882 0.392828 7.56101 0.772233 7.18161L5.1083 2.84554C5.4877 2.46614 5.97551 2.27643 6.46332 2.27643L6.43622 2.33063ZM17.3848 0.948514L9.74247 14.0922C9.20046 15.0136 9.52566 16.1789 10.42 16.6938C11.3143 17.2359 12.5067 16.9107 13.0216 16.0163L20.6639 2.87264C21.2059 1.95123 20.8807 0.785912 19.9864 0.271004C19.6883 0.108402 19.3631 0 19.0379 0C18.3875 0 17.7371 0.352305 17.3848 0.948514ZM23.9431 14.7968C23.4553 14.7968 22.9675 14.6071 22.5881 14.2277C21.8563 13.496 21.8563 12.2765 22.5881 11.5448L25.5691 8.56373L22.5881 5.58268C22.2087 5.20328 22.0189 4.71547 22.0189 4.22766C22.0189 3.73986 22.2087 3.25205 22.5881 2.87264C23.3198 2.11383 24.5393 2.11383 25.271 2.87264L29.6071 7.20871C29.9865 7.58811 30.1762 8.07592 30.1762 8.56373C30.1762 9.05153 29.9865 9.53934 29.6071 9.91875L25.271 14.2548C24.8916 14.6342 24.4038 14.8239 23.916 14.8239L23.9431 14.7968Z"
                            fill="url(#paint0_linear_587_5550)"
                          />
                          <defs>
                            <linearGradient
                              id="paint0_linear_587_5550"
                              x1="7.30343"
                              y1="16.4499"
                              x2="25.7031"
                              y2="-1.94975"
                              gradientUnits="userSpaceOnUse"
                            >
                              <stop stop-color="#64D3DD" />
                              <stop offset="1" stop-color="#3381E8" />
                            </linearGradient>
                          </defs>
                        </svg>
                      ),
                    },
                    {
                      title:
                        navData?.themeOption?.megaMenu?.topNav?.[1]?.tabs?.[0]
                          ?.tabLinksRightColumn[2]?.linkText,
                      // "Cloud-Native Application Protection Platform (CNAPP)",
                      description:
                        navData?.themeOption?.megaMenu?.topNav?.[1]?.tabs?.[0]
                          ?.tabLinksRightColumn[2]?.linkDescription,
                      link: navData?.themeOption?.megaMenu?.topNav?.[1]
                        ?.tabs?.[0]?.tabLinksRightColumn[2]?.linkUrl,
                      icon: (
                        <svg
                          style={{ maxWidth: "25px", maxHeight: "25px" }}
                          className="no-hover"
                          width="29"
                          height="28"
                          viewBox="0 0 29 28"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M17.2533 16.0371L20.2876 16.5384C19.839 17.7785 18.9947 18.8603 17.8601 19.5991L16.6728 16.7495C16.5673 16.4856 16.6728 16.1954 16.9103 16.0635C16.963 16.0371 17.0422 16.0107 17.095 16.0107C17.1477 16.0107 17.1741 16.0107 17.2005 16.0107L17.2533 16.0371ZM11.5013 14.2693C11.5013 14.2693 11.686 14.1901 11.7651 14.0846C11.9498 13.8735 11.8971 13.5569 11.7124 13.3722L9.41687 11.3141C8.73085 12.4223 8.41423 13.7416 8.57254 15.1136L11.5013 14.2693ZM12.8469 11.9474C12.8469 11.9474 13.0316 12.0529 13.1372 12.0529C13.401 12.0529 13.6385 11.8418 13.6385 11.5516L13.8232 8.49092C13.6121 8.49092 13.401 8.5437 13.19 8.59647C12.0554 8.86032 11.0528 9.41441 10.2876 10.1796L12.7942 11.9738L12.8469 11.9474ZM15.4855 11.5516C15.4855 11.5516 15.5382 11.7627 15.591 11.8418C15.7757 12.0529 16.0659 12.1057 16.3034 11.9474L18.81 10.1796C17.8601 9.25609 16.6464 8.64924 15.3008 8.49092L15.4855 11.5516ZM13.7177 15.1664L14.562 15.5622L15.4063 15.1664L15.6174 14.2429L15.0369 13.5041H14.0871L13.5066 14.2429L13.7177 15.1664ZM19.7071 11.3141L17.438 13.3458C17.438 13.3458 17.306 13.5041 17.2797 13.636C17.2269 13.8999 17.3852 14.1637 17.6491 14.2429L20.6042 15.1136C20.657 14.4804 20.6042 13.8207 20.4723 13.1611C20.314 12.5015 20.0501 11.8682 19.7071 11.3141ZM15.0105 17.5411C15.0105 17.5411 14.8786 17.3827 14.7731 17.33C14.6939 17.3036 14.6148 17.2772 14.5356 17.2772C14.3509 17.2772 14.1926 17.3827 14.0871 17.5411L12.6095 20.2324C13.6385 20.5754 14.7731 20.6545 15.9076 20.3907C16.1187 20.3379 16.3034 20.2851 16.5145 20.2324L15.0369 17.5411H15.0105ZM12.0026 16.0371C12.0026 16.0371 11.9235 16.0371 11.8971 16.0371L8.88916 16.5384C9.36409 17.8313 10.2348 18.8867 11.3166 19.5727L12.4776 16.7495C12.4776 16.7495 12.5303 16.5384 12.5039 16.4329C12.4512 16.1954 12.2401 16.0371 12.0026 16.0371ZM26.1451 6.48564L28.5462 16.9606C28.6781 17.5147 28.5462 18.0951 28.1768 18.5173L21.4221 26.9078C21.0791 27.3564 20.525 27.5938 19.971 27.5938H9.12663C8.54615 27.5938 8.01845 27.33 7.67544 26.9078L0.92082 18.5173C0.92082 18.5173 0.841672 18.4118 0.815287 18.359C0.551435 17.9368 0.445888 17.4355 0.551429 16.9342L2.95248 6.45926C3.08441 5.90517 3.45381 5.45662 3.95513 5.19277L13.7177 0.522586C13.9287 0.417045 14.1926 0.364276 14.4301 0.337891C14.7467 0.337891 15.0633 0.39066 15.3272 0.522586L25.0897 5.19277C25.591 5.43024 25.9604 5.90517 26.0923 6.45926L26.1451 6.48564ZM24.8522 16.8287C24.9314 16.512 24.6939 16.1954 24.3509 16.1163C24.2981 16.1163 24.219 16.0899 24.1926 16.0635C23.9815 16.0371 23.8232 16.0371 23.6385 16.0107C23.2427 15.9579 22.8997 15.9316 22.5831 15.826C22.4512 15.7732 22.372 15.6413 22.3192 15.5622L22.0818 15.483C22.2137 14.5859 22.1609 13.6888 21.9498 12.7653C21.7388 11.8418 21.3694 10.9711 20.8681 10.2323C20.9208 10.1796 21.0528 10.074 21.0791 10.0477C21.0791 9.94211 21.0791 9.83657 21.1847 9.70464C21.4221 9.49356 21.7124 9.30887 22.0554 9.09778C22.2137 8.99224 22.372 8.93947 22.5303 8.80754C22.5567 8.78116 22.6095 8.72839 22.6622 8.702C22.9525 8.49092 23.0053 8.09515 22.7942 7.83129C22.5831 7.56744 22.2137 7.56744 21.9235 7.77852C21.8707 7.80491 21.8179 7.85768 21.7915 7.88407C21.6332 8.01599 21.5277 8.14791 21.3958 8.27984C21.1055 8.57008 20.8681 8.80754 20.6042 8.99224C20.4987 9.04501 20.314 9.04502 20.2612 9.01863L20.0501 9.17694C18.7836 7.85767 17.0686 6.98696 15.1952 6.82865C15.1952 6.7495 15.1952 6.61757 15.1952 6.5648C15.1161 6.48565 15.0369 6.43288 15.0105 6.27457C15.0105 5.95794 15.0105 5.61493 15.0897 5.21915C15.1161 5.03446 15.1688 4.87615 15.1688 4.66507C15.1688 4.61229 15.1688 4.55952 15.1688 4.50675C15.1688 4.13736 14.905 3.84712 14.5884 3.84712C14.2717 3.84712 14.0079 4.13736 14.0079 4.50675C14.0079 4.55952 14.0079 4.61229 14.0079 4.66507C14.0079 4.87615 14.0607 5.03446 14.0871 5.21915C14.1398 5.61493 14.1662 5.95794 14.1398 6.27457C14.1398 6.38011 14.0343 6.51203 13.9551 6.5648V6.80227C13.5857 6.82866 13.2427 6.88142 12.8733 6.96058C11.343 7.30358 10.0501 8.09515 9.04747 9.15056C8.9947 9.09778 8.86277 9.01863 8.83639 8.99224C8.73085 8.99224 8.62531 9.04501 8.49339 8.96586C8.22953 8.78116 7.99207 8.54369 7.70183 8.25346C7.56991 8.12153 7.46436 7.9896 7.30605 7.85767C7.27966 7.83129 7.2269 7.77853 7.17413 7.75214C7.0422 7.6466 6.91027 7.59383 6.77834 7.59383C6.59365 7.59383 6.43533 7.64659 6.30341 7.8049C6.09233 8.06876 6.17148 8.43815 6.43533 8.67562C6.46172 8.70201 6.5145 8.75478 6.56727 8.78116C6.72558 8.91309 6.88389 8.96586 7.0422 9.0714C7.38521 9.28248 7.67544 9.46718 7.91291 9.67826C7.99206 9.7838 8.01845 9.94211 8.01845 10.0213L8.20315 10.1796C7.20051 11.6835 6.72557 13.5569 7.01581 15.4566L6.77834 15.5358C6.77834 15.5358 6.62004 15.7469 6.5145 15.7996C6.22426 15.9052 5.88125 15.9316 5.45908 15.9843C5.27439 15.9843 5.08969 15.9843 4.905 16.0371C4.85222 16.0371 4.79945 16.0371 4.74668 16.0635C4.40367 16.1426 4.19259 16.4593 4.24536 16.7759C4.32452 17.0925 4.64115 17.2772 5.01054 17.198C5.06331 17.198 5.11607 17.198 5.16884 17.1717C5.37993 17.1189 5.51185 17.0397 5.69655 16.9606C6.09233 16.8287 6.40895 16.6967 6.72557 16.6703C6.8575 16.6703 6.98943 16.7495 7.06858 16.7759L7.33243 16.7231C7.91291 18.5437 9.15302 20.0213 10.7097 20.9184L10.6042 21.1822C10.6042 21.1822 10.6834 21.4197 10.657 21.5252C10.5514 21.8155 10.3403 22.1321 10.1293 22.4751C10.0237 22.6334 9.91819 22.7653 9.81265 22.95C9.81265 23.0028 9.75987 23.0556 9.73349 23.1083C9.57517 23.425 9.68072 23.7943 9.97095 23.9263C10.2612 24.0582 10.6306 23.9263 10.7889 23.6097C10.7889 23.5569 10.8417 23.5041 10.8681 23.4513C10.9472 23.2666 10.9736 23.1083 11.0264 22.9236C11.1847 22.5279 11.2638 22.1321 11.4749 21.8682C11.5277 21.7891 11.6332 21.7627 11.7388 21.7363L11.8707 21.4988C13.2163 22.0265 14.7467 22.1585 16.2506 21.8155C16.5936 21.7363 16.9367 21.6308 17.2533 21.5252C17.2797 21.6044 17.3588 21.7099 17.3852 21.7627C17.4907 21.7891 17.5963 21.8155 17.6754 21.9474C17.8338 22.2112 17.9393 22.5543 18.0712 22.9236C18.124 23.1083 18.1504 23.2666 18.2295 23.4513C18.2295 23.5041 18.2823 23.5569 18.3087 23.6097C18.467 23.9263 18.8364 24.0846 19.1266 23.9527C19.4169 23.8207 19.5224 23.4513 19.3641 23.1347C19.3641 23.0819 19.3113 23.0292 19.2849 22.9764C19.1794 22.7917 19.0739 22.6598 18.9683 22.5015C18.7572 22.1585 18.5725 21.8682 18.4406 21.578C18.3878 21.4197 18.4406 21.3405 18.4934 21.235C18.4934 21.235 18.4142 21.0767 18.3878 20.9975C19.9973 20.0476 21.1847 18.5173 21.7652 16.7495C21.8443 16.7495 21.9762 16.7759 22.0026 16.8023C22.0818 16.7495 22.1609 16.6703 22.3192 16.6703C22.6359 16.7231 22.9525 16.8287 23.3483 16.9606C23.533 17.0397 23.6649 17.1189 23.876 17.1717C23.9287 17.1717 23.9815 17.1717 24.0343 17.198C24.3773 17.2772 24.7203 17.0925 24.7995 16.7759L24.8522 16.8287Z"
                            fill="url(#paint0_linear_587_5548)"
                          />
                          <defs>
                            <linearGradient
                              id="paint0_linear_587_5548"
                              x1="4.74668"
                              y1="23.979"
                              x2="24.4037"
                              y2="4.32205"
                              gradientUnits="userSpaceOnUse"
                            >
                              <stop stop-color="#64D3DD" />
                              <stop offset="1" stop-color="#3381E8" />
                            </linearGradient>
                          </defs>
                        </svg>
                      ),
                    },
                    {
                      title:
                        navData?.themeOption?.megaMenu?.topNav?.[1]?.tabs?.[0]
                          ?.tabLinksLeftColumn[3]?.linkText,
                      // "Cloud-Native Application Protection Platform (CNAPP)",
                      description:
                        navData?.themeOption?.megaMenu?.topNav?.[1]?.tabs?.[0]
                          ?.tabLinksLeftColumn[3]?.linkDescription,
                      link: navData?.themeOption?.megaMenu?.topNav?.[1]
                        ?.tabs?.[0]?.tabLinksLeftColumn[3]?.linkUrl,
                      icon: (
                        <svg
                          style={{ maxWidth: "25px", maxHeight: "25px" }}
                          className="no-hover"
                          width="31"
                          height="27"
                          viewBox="0 0 31 27"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M25.9484 5.73701C25.8671 5.51944 25.7316 5.32906 25.569 5.16588L21.3956 0.9776C20.691 0.270487 19.5256 0.270487 18.7939 0.9776C18.4416 1.33116 18.2519 1.8207 18.2519 2.28304C18.2519 2.74538 18.4416 3.23492 18.7939 3.58848L19.8237 4.62195H6.16521C5.1625 4.62195 4.32239 5.43785 4.32239 6.47132C4.32239 7.5048 5.1354 8.3207 6.16521 8.3207C11.3143 8.3207 11.3143 9.9253 11.3143 13.4881C11.3143 17.0508 11.3143 22.191 19.8508 22.327L18.821 23.3604C18.1164 24.0676 18.1164 25.237 18.821 25.9713C19.1733 26.3249 19.6611 26.5153 20.1218 26.5153C20.5826 26.5153 21.0704 26.3249 21.4227 25.9713L25.569 21.8102C25.569 21.8102 25.6774 21.6199 25.7587 21.5383C25.84 21.4295 25.9213 21.3479 25.9755 21.2119C26.0568 20.9943 26.111 20.7768 26.111 20.532V20.4776C26.111 20.2328 26.0568 20.0153 25.9755 19.7705C25.9213 19.6345 25.8129 19.4985 25.7045 19.3625C25.6503 19.3081 25.6232 19.2266 25.569 19.1722L21.4227 15.0111C20.7181 14.304 19.5527 14.304 18.821 15.0111C18.4687 15.3646 18.279 15.8542 18.279 16.3165C18.279 16.7789 18.4687 17.2684 18.821 17.622L19.8237 18.6282C14.9999 18.5466 14.9728 16.942 14.9728 13.4881C14.9728 11.9107 14.9728 9.97969 14.1869 8.3207H19.8237L18.7939 9.35417C18.0893 10.0613 18.0893 11.2307 18.7939 11.965C19.1462 12.3186 19.634 12.509 20.0947 12.509C20.5555 12.509 21.0433 12.3186 21.3956 11.965L25.5419 7.80396C25.8671 7.4504 26.0568 7.01526 26.0568 6.58011V6.47132C26.0568 6.22655 26.0026 6.00898 25.9213 5.8186L25.9484 5.73701Z"
                            fill="url(#paint0_linear_587_5536)"
                          />
                          <path
                            d="M28.7397 7.91282C29.5527 7.91282 30.2031 7.2601 30.2031 6.44421C30.2031 5.62831 29.5527 4.97559 28.7397 4.97559C27.9267 4.97559 27.2762 5.62831 27.2762 6.44421C27.2762 7.2601 27.9267 7.91282 28.7397 7.91282Z"
                            fill="#4EAEE2"
                          />
                          <path
                            d="M1.66654 7.91282C2.47955 7.91282 3.12995 7.2601 3.12995 6.44421C3.12995 5.62831 2.47955 4.97559 1.66654 4.97559C0.853532 4.97559 0.203125 5.62831 0.203125 6.44421C0.203125 7.2601 0.853532 7.91282 1.66654 7.91282Z"
                            fill="#4EAEE2"
                          />
                          <path
                            d="M28.7397 21.8923C29.5527 21.8923 30.2031 21.2396 30.2031 20.4237C30.2031 19.6078 29.5527 18.9551 28.7397 18.9551C27.9267 18.9551 27.2762 19.6078 27.2762 20.4237C27.2762 21.2396 27.9267 21.8923 28.7397 21.8923Z"
                            fill="#4EAEE2"
                          />
                          <defs>
                            <linearGradient
                              id="paint0_linear_587_5536"
                              x1="10.7994"
                              y1="17.8667"
                              x2="26.7592"
                              y2="2.05666"
                              gradientUnits="userSpaceOnUse"
                            >
                              <stop stop-color="#64D3DD" />
                              <stop offset="1" stop-color="#3381E8" />
                            </linearGradient>
                          </defs>
                        </svg>
                      ),
                    },
                  ],
                },
                {
                  title:
                    navData?.themeOption?.megaMenu?.topNav?.[1]?.tabs?.[1]
                      ?.tabTitle,
                  links: [
                    {
                      title:
                        navData?.themeOption?.megaMenu?.topNav?.[1]?.tabs?.[1]
                          ?.tabLinksLeftColumn[0]?.linkText,
                      // "Cloud-Native Application Protection Platform (CNAPP)",
                      description:
                        navData?.themeOption?.megaMenu?.topNav?.[1]?.tabs?.[1]
                          ?.tabLinksLeftColumn[0]?.linkDescription,
                      link: navData?.themeOption?.megaMenu?.topNav?.[1]
                        ?.tabs?.[1]?.tabLinksLeftColumn[0]?.linkUrl,
                      icon: (
                        <img
                          style={{ maxWidth: "34px" }}
                          src="data:image/png;base64,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"
                          alt="AWS"
                        />
                      ),
                    },
                    {
                      title:
                        navData?.themeOption?.megaMenu?.topNav?.[1]?.tabs?.[1]
                          ?.tabLinksRightColumn[0]?.linkText,
                      // "Cloud-Native Application Protection Platform (CNAPP)",
                      description:
                        navData?.themeOption?.megaMenu?.topNav?.[1]?.tabs?.[1]
                          ?.tabLinksRightColumn[0]?.linkDescription,
                      link: navData?.themeOption?.megaMenu?.topNav?.[1]
                        ?.tabs?.[1]?.tabLinksRightColumn[0]?.linkUrl,
                      icon: (
                        <img
                          style={{ maxWidth: "27px" }}
                          src="data:image/png;base64,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"
                          alt="Azure"
                        />
                      ),
                    },
                    {
                      title:
                        navData?.themeOption?.megaMenu?.topNav?.[1]?.tabs?.[1]
                          ?.tabLinksLeftColumn[1]?.linkText,
                      // "Cloud-Native Application Protection Platform (CNAPP)",
                      description:
                        navData?.themeOption?.megaMenu?.topNav?.[1]?.tabs?.[1]
                          ?.tabLinksLeftColumn[1]?.linkDescription,
                      link: navData?.themeOption?.megaMenu?.topNav?.[1]
                        ?.tabs?.[1]?.tabLinksLeftColumn[1]?.linkUrl,
                      icon: (
                        <img
                          style={{ maxWidth: "30px" }}
                          src="data:image/png;base64,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"
                          alt="GCP"
                        />
                      ),
                    },
                    {
                      title:
                        navData?.themeOption?.megaMenu?.topNav?.[1]?.tabs?.[1]
                          ?.tabLinksRightColumn[1]?.linkText,
                      // "Cloud-Native Application Protection Platform (CNAPP)",
                      description:
                        navData?.themeOption?.megaMenu?.topNav?.[1]?.tabs?.[1]
                          ?.tabLinksRightColumn[1]?.linkDescription,
                      link: navData?.themeOption?.megaMenu?.topNav?.[1]
                        ?.tabs?.[1]?.tabLinksRightColumn[1]?.linkUrl,
                      icon: (
                        <svg
                          style={{ maxWidth: "25px", maxHeight: "25px" }}
                          className="no-hover"
                          width="29"
                          height="20"
                          viewBox="0 0 29 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M6.04862 8.13435C6.25719 8.13435 6.44259 8.088 6.62799 8.01848C6.69751 7.9953 6.74386 7.94895 6.79021 7.92578C6.90609 7.85625 6.99879 7.8099 7.09148 7.7172C7.13783 7.67085 7.18418 7.60133 7.23053 7.53181C7.30006 7.43911 7.36958 7.34641 7.41593 7.25371C7.46228 7.18418 7.46228 7.09148 7.48546 7.02196C7.48546 6.95244 7.55498 6.88291 7.55498 6.81339C7.85625 4.70448 9.68706 3.1286 11.8191 3.1286C13.4877 3.1286 14.9709 4.05559 15.6893 5.58512C16.0601 6.37307 17.0103 6.67434 17.7751 6.30354C18.5398 5.93275 18.8875 5.00575 18.5167 4.21781C17.2884 1.66858 14.6696 0 11.8191 0C8.57467 0 5.72417 2.15526 4.75083 5.16798C2.03938 5.74735 0 8.15752 0 11.0312C0 13.9049 1.90033 16.2455 4.63496 16.8712C4.68131 16.8712 4.72766 16.8712 4.77401 16.8712C4.9594 16.9639 5.19115 17.0103 5.39973 17.0103H6.90609C7.76355 17.0103 8.4588 16.315 8.4588 15.4576C8.4588 14.6001 7.76355 13.9049 6.90609 13.9049H5.49242C5.49242 13.9049 5.39973 13.8353 5.3302 13.8353C4.00924 13.5341 3.10542 12.3753 3.10542 11.0312C3.10542 9.43214 4.40321 8.15752 5.97909 8.15752L6.04862 8.13435Z"
                            fill="url(#paint0_linear_604_6182)"
                          />
                          <path
                            d="M21.9928 6.5354C19.7449 6.5354 17.6591 7.67097 16.4309 9.50177C16.0137 9.40907 15.5966 9.33955 15.1563 9.33955C12.2131 9.33955 9.82605 11.7266 9.82605 14.6698C9.82605 17.6129 12.2131 20 15.1563 20H22.5258C22.6881 20 22.8503 19.9768 22.9893 19.9304C26.2801 19.4438 28.7135 16.6396 28.7135 13.2793C28.7135 9.5713 25.7008 6.55858 21.9928 6.55858V6.5354ZM22.3636 16.8482C22.3636 16.8482 22.2709 16.8482 22.2246 16.8482H15.1563C13.9512 16.8482 12.9546 15.8517 12.9546 14.6466C12.9546 13.4415 13.9512 12.445 15.1563 12.445C15.5734 12.445 15.9674 12.5608 16.315 12.7694C16.709 13.0243 17.1956 13.0707 17.636 12.9316C18.0763 12.7694 18.4239 12.445 18.5861 12.0047C19.1191 10.591 20.4633 9.64082 21.9696 9.64082C23.9627 9.64082 25.5849 11.2631 25.5849 13.2561C25.5849 15.1101 24.1944 16.6628 22.3636 16.8482Z"
                            fill="url(#paint1_linear_604_6182)"
                          />
                          <defs>
                            <linearGradient
                              id="paint0_linear_604_6182"
                              x1="14.9516"
                              y1="-1.00411e-06"
                              x2="0.179065"
                              y2="11.291"
                              gradientUnits="userSpaceOnUse"
                            >
                              <stop stop-color="#3482E8" />
                              <stop offset="1" stop-color="#64D2DE" />
                            </linearGradient>
                            <linearGradient
                              id="paint1_linear_604_6182"
                              x1="24.9552"
                              y1="6.5354"
                              x2="12.8403"
                              y2="18.3724"
                              gradientUnits="userSpaceOnUse"
                            >
                              <stop stop-color="#3482E8" />
                              <stop offset="1" stop-color="#64D2DE" />
                            </linearGradient>
                          </defs>
                        </svg>
                      ),
                    },
                    {
                      title:
                        navData?.themeOption?.megaMenu?.topNav?.[1]?.tabs?.[1]
                          ?.tabLinksLeftColumn[2]?.linkText,
                      // "Cloud-Native Application Protection Platform (CNAPP)",
                      description:
                        navData?.themeOption?.megaMenu?.topNav?.[1]?.tabs?.[1]
                          ?.tabLinksLeftColumn[2]?.linkDescription,
                      link: navData?.themeOption?.megaMenu?.topNav?.[1]
                        ?.tabs?.[1]?.tabLinksLeftColumn[2]?.linkUrl,
                      icon: (
                        <img
                          style={{ maxWidth: "34px" }}
                          src="data:image/png;base64,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"
                          alt="AWS"
                        />
                      ),
                    },
                  ],
                },
                {
                  title:
                    navData?.themeOption?.megaMenu?.topNav?.[1]?.tabs?.[2]
                      ?.tabTitle,
                  links: [
                    {
                      title:
                        navData?.themeOption?.megaMenu?.topNav?.[1]?.tabs?.[2]
                          ?.tabLinksRightColumn[0]?.linkText,
                      // "Cloud-Native Application Protection Platform (CNAPP)",
                      description:
                        navData?.themeOption?.megaMenu?.topNav?.[1]?.tabs?.[2]
                          ?.tabLinksRightColumn[0]?.linkDescription,
                      link: navData?.themeOption?.megaMenu?.topNav?.[1]
                        ?.tabs?.[2]?.tabLinksRightColumn[0]?.linkUrl,
                      icon: (
                        <svg
                          style={{ maxWidth: "25px", maxHeight: "25px" }}
                          className="no-hover"
                          width="26"
                          height="26"
                          viewBox="0 0 26 26"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M12.6602 4.01056C13.7676 4.01056 14.6655 3.11268 14.6655 2.00528C14.6655 0.897887 13.7676 0 12.6602 0C11.5528 0 10.6549 0.897887 10.6549 2.00528C10.6549 3.11268 11.5528 4.01056 12.6602 4.01056ZM2.00528 10.6849C0.897887 10.6849 0 11.5827 0 12.6901C0 13.7975 0.897887 14.6954 2.00528 14.6954C3.11268 14.6954 4.01056 13.7975 4.01056 12.6901C4.01056 11.5827 3.11268 10.6849 2.00528 10.6849ZM12.7799 10.6849C11.6725 10.6849 10.7746 11.5827 10.7746 12.6901C10.7746 13.7975 11.6725 14.6954 12.7799 14.6954C13.8873 14.6954 14.7852 13.7975 14.7852 12.6901C14.7852 11.5827 13.8873 10.6849 12.7799 10.6849ZM0 23.5246C0 22.4173 0.897887 21.5194 2.00528 21.5194C3.11268 21.5194 4.01056 22.4173 4.01056 23.5246C4.01056 24.632 3.11268 25.5299 2.00528 25.5299C0.897887 25.5299 0 24.632 0 23.5246ZM25.4401 2.00528C25.4401 3.11268 24.5423 4.01056 23.4349 4.01056C22.3275 4.01056 21.4296 3.11268 21.4296 2.00528C21.4296 0.897887 22.3275 0 23.4349 0C24.5423 0 25.4401 0.897887 25.4401 2.00528ZM23.4349 21.4894C22.3275 21.4894 21.4296 22.3873 21.4296 23.4947C21.4296 24.6021 22.3275 25.5 23.4349 25.5C24.5423 25.5 25.4401 24.6021 25.4401 23.4947C25.4401 22.3873 24.5423 21.4894 23.4349 21.4894ZM0 2.00528C0 0.897887 0.897887 0 2.00528 0C3.11268 0 4.01056 0.897887 4.01056 2.00528C4.01056 3.11268 3.11268 4.01056 2.00528 4.01056C0.897887 4.01056 0 3.11268 0 2.00528Z"
                            fill="url(#paint0_linear_604_6203)"
                          />
                          <path
                            d="M24.9014 14.2165C25.6796 13.4383 25.6796 12.1513 24.9014 11.3732C24.1233 10.595 22.8363 10.595 22.0581 11.3732L12.7201 20.6813L8.76939 16.7006C7.99122 15.9225 6.70425 15.8925 5.92608 16.7006C5.14791 17.4788 5.11798 18.7658 5.92608 19.544L11.2535 24.9013C11.6426 25.2904 12.1514 25.4999 12.6902 25.4999C12.9595 25.4999 13.199 25.4401 13.4384 25.3503C13.7078 25.2605 13.9771 25.1109 14.1866 24.9013L24.9014 14.2165Z"
                            fill="#4EAEE2"
                          />
                          <defs>
                            <linearGradient
                              id="paint0_linear_604_6203"
                              x1="2.82642e-07"
                              y1="25.9999"
                              x2="25.9999"
                              y2="0.0457152"
                              gradientUnits="userSpaceOnUse"
                            >
                              <stop stop-color="#63D1DE" />
                              <stop offset="1" stop-color="#3C90E7" />
                            </linearGradient>
                          </defs>
                        </svg>
                      ),
                    },
                    {
                      title:
                        navData?.themeOption?.megaMenu?.topNav?.[1]?.tabs?.[2]
                          ?.tabLinksLeftColumn[0]?.linkText,
                      // "Cloud-Native Application Protection Platform (CNAPP)",
                      description:
                        navData?.themeOption?.megaMenu?.topNav?.[1]?.tabs?.[2]
                          ?.tabLinksLeftColumn[0]?.linkDescription,
                      link: navData?.themeOption?.megaMenu?.topNav?.[1]
                        ?.tabs?.[2]?.tabLinksLeftColumn[0]?.linkUrl,
                      icon: (
                        <svg
                          style={{ maxWidth: "25px", maxHeight: "25px" }}
                          className="no-hover"
                          width="25"
                          height="31"
                          viewBox="0 0 25 31"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M11 10C12.1045 10 13 9.25187 13 8.32918V1.67082C13 0.74813 12.1045 0 11 0C9.89552 0 9 0.74813 9 1.67082V8.32918C9 9.25187 9.89552 10 11 10ZM2 8C3.10448 8 4 7.10448 4 6C4 4.89552 3.10448 4 2 4C0.895522 4 0 4.89552 0 6C0 7.10448 0.895522 8 2 8ZM24.6554 14.5209C24.6554 14.5209 24.5758 14.344 24.4963 14.2935L19.4327 9.49271C18.7434 8.83576 17.6034 8.83576 16.9141 9.49271C16.5695 9.82119 16.3839 10.2507 16.3839 10.7055C16.3839 11.1604 16.5695 11.5646 16.9141 11.9184L18.9289 13.8387H1.80276C0.821845 13.7881 0 14.5462 0 15.481C0 16.4159 0.795334 17.174 1.77625 17.174H18.9024L16.8876 19.0943C16.1983 19.7512 16.1983 20.8377 16.8876 21.4947C17.2322 21.8231 17.6829 22 18.1601 22C18.6373 22 19.0615 21.8231 19.4327 21.4947L24.4963 16.6939C24.5422 16.6501 24.5793 16.5894 24.6178 16.5265C24.6459 16.4805 24.6748 16.4333 24.7084 16.3907C24.7225 16.3705 24.7385 16.3503 24.7549 16.3296C24.8 16.2727 24.848 16.2122 24.8674 16.138C24.947 15.9359 25 15.7337 25 15.5063V15.4558C25 15.2284 24.947 15.001 24.8674 14.7988C24.8269 14.7022 24.7708 14.6351 24.7111 14.5637C24.6927 14.5417 24.674 14.5194 24.6554 14.4956V14.5209ZM0 25C0 23.8955 0.895522 23 2 23C3.10448 23 4 23.8955 4 25C4 26.1045 3.10448 27 2 27C0.895522 27 0 26.1045 0 25ZM9 21.8379C9 20.8229 9.89552 20 11 20C12.1045 20 13 20.8229 13 21.8379V29.1621C13 30.1771 12.1045 31 11 31C9.89552 31 9 30.1771 9 29.1621V21.8379Z"
                            fill="url(#paint0_linear_604_6192)"
                          />
                          <defs>
                            <linearGradient
                              id="paint0_linear_604_6192"
                              x1="24.5"
                              y1="1"
                              x2="-2.47509"
                              y2="2.66976"
                              gradientUnits="userSpaceOnUse"
                            >
                              <stop stop-color="#3C90E7" />
                              <stop offset="1" stop-color="#63D1DE" />
                            </linearGradient>
                          </defs>
                        </svg>
                      ),
                    },
                    {
                      title:
                        navData?.themeOption?.megaMenu?.topNav?.[1]?.tabs?.[2]
                          ?.tabLinksLeftColumn[1]?.linkText,
                      // "Cloud-Native Application Protection Platform (CNAPP)",
                      description:
                        navData?.themeOption?.megaMenu?.topNav?.[1]?.tabs?.[2]
                          ?.tabLinksLeftColumn[1]?.linkDescription,
                      link: navData?.themeOption?.megaMenu?.topNav?.[1]
                        ?.tabs?.[2]?.tabLinksLeftColumn[1]?.linkUrl,
                      icon: (
                        <svg
                          style={{ maxWidth: "25px", maxHeight: "25px" }}
                          className="no-hover"
                          width="30"
                          height="18"
                          viewBox="0 0 30 18"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M11.0363 7.02591H16.0104C17.1295 7.02591 18.0311 7.92747 18.0311 9.04664C18.0311 10.1658 17.1295 11.0674 16.0104 11.0674H11.0363V15.9793C11.0363 17.0985 10.1347 18 9.01555 18C7.89638 18 6.99482 17.0985 6.99482 15.9793V11.0674H2.02073C0.901555 11.0674 0 10.1658 0 9.04664C0 7.92747 0.901555 7.02591 2.02073 7.02591H6.99482V2.02073C6.99482 0.901555 7.89638 0 9.01555 0C10.1347 0 11.0363 0.901555 11.0363 2.02073V7.02591ZM23.6581 1.86537L29.4094 7.61667C29.8135 8.02082 30 8.51823 30 9.04672C30 9.57522 29.8135 10.0726 29.4094 10.4768L23.6581 16.2281C23.2539 16.6322 22.7565 16.8188 22.228 16.8188C21.6995 16.8188 21.2021 16.6322 20.7979 16.2281C20.0207 15.4509 20.0207 14.1452 20.7979 13.368L25.1192 9.04672L20.7979 4.72548C20.3938 4.32133 20.2073 3.82392 20.2073 3.29543C20.2073 2.76693 20.3938 2.26952 20.7979 1.86537C21.5752 1.08817 22.8809 1.08817 23.6581 1.86537Z"
                            fill="url(#paint0_linear_604_6224)"
                          />
                          <defs>
                            <linearGradient
                              id="paint0_linear_604_6224"
                              x1="24"
                              y1="-0.999998"
                              x2="3.5"
                              y2="19.5"
                              gradientUnits="userSpaceOnUse"
                            >
                              <stop stop-color="#3C90E7" />
                              <stop offset="1" stop-color="#63D1DE" />
                            </linearGradient>
                          </defs>
                        </svg>
                      ),
                    },
                    {
                      title:
                        navData?.themeOption?.megaMenu?.topNav?.[1]?.tabs?.[2]
                          ?.tabLinksRightColumn[1]?.linkText,
                      // "Cloud-Native Application Protection Platform (CNAPP)",
                      description:
                        navData?.themeOption?.megaMenu?.topNav?.[1]?.tabs?.[2]
                          ?.tabLinksRightColumn[1]?.linkDescription,
                      link: navData?.themeOption?.megaMenu?.topNav?.[1]
                        ?.tabs?.[2]?.tabLinksRightColumn[1]?.linkUrl,
                      icon: (
                        <svg
                          style={{ maxWidth: "25px", maxHeight: "25px" }}
                          className="no-hover"
                          width="31"
                          height="27"
                          viewBox="0 0 31 27"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M25.9484 5.73701C25.8671 5.51944 25.7316 5.32906 25.569 5.16588L21.3956 0.9776C20.691 0.270487 19.5256 0.270487 18.7939 0.9776C18.4416 1.33116 18.2519 1.8207 18.2519 2.28304C18.2519 2.74538 18.4416 3.23492 18.7939 3.58848L19.8237 4.62195H6.16521C5.1625 4.62195 4.32239 5.43785 4.32239 6.47132C4.32239 7.5048 5.1354 8.3207 6.16521 8.3207C11.3143 8.3207 11.3143 9.9253 11.3143 13.4881C11.3143 17.0508 11.3143 22.191 19.8508 22.327L18.821 23.3604C18.1164 24.0676 18.1164 25.237 18.821 25.9713C19.1733 26.3249 19.6611 26.5153 20.1218 26.5153C20.5826 26.5153 21.0704 26.3249 21.4227 25.9713L25.569 21.8102C25.569 21.8102 25.6774 21.6199 25.7587 21.5383C25.84 21.4295 25.9213 21.3479 25.9755 21.2119C26.0568 20.9943 26.111 20.7768 26.111 20.532V20.4776C26.111 20.2328 26.0568 20.0153 25.9755 19.7705C25.9213 19.6345 25.8129 19.4985 25.7045 19.3625C25.6503 19.3081 25.6232 19.2266 25.569 19.1722L21.4227 15.0111C20.7181 14.304 19.5527 14.304 18.821 15.0111C18.4687 15.3646 18.279 15.8542 18.279 16.3165C18.279 16.7789 18.4687 17.2684 18.821 17.622L19.8237 18.6282C14.9999 18.5466 14.9728 16.942 14.9728 13.4881C14.9728 11.9107 14.9728 9.97969 14.1869 8.3207H19.8237L18.7939 9.35417C18.0893 10.0613 18.0893 11.2307 18.7939 11.965C19.1462 12.3186 19.634 12.509 20.0947 12.509C20.5555 12.509 21.0433 12.3186 21.3956 11.965L25.5419 7.80396C25.8671 7.4504 26.0568 7.01526 26.0568 6.58011V6.47132C26.0568 6.22655 26.0026 6.00898 25.9213 5.8186L25.9484 5.73701Z"
                            fill="url(#paint0_linear_587_5536)"
                          />
                          <path
                            d="M28.7397 7.91282C29.5527 7.91282 30.2031 7.2601 30.2031 6.44421C30.2031 5.62831 29.5527 4.97559 28.7397 4.97559C27.9267 4.97559 27.2762 5.62831 27.2762 6.44421C27.2762 7.2601 27.9267 7.91282 28.7397 7.91282Z"
                            fill="#4EAEE2"
                          />
                          <path
                            d="M1.66654 7.91282C2.47955 7.91282 3.12995 7.2601 3.12995 6.44421C3.12995 5.62831 2.47955 4.97559 1.66654 4.97559C0.853532 4.97559 0.203125 5.62831 0.203125 6.44421C0.203125 7.2601 0.853532 7.91282 1.66654 7.91282Z"
                            fill="#4EAEE2"
                          />
                          <path
                            d="M28.7397 21.8923C29.5527 21.8923 30.2031 21.2396 30.2031 20.4237C30.2031 19.6078 29.5527 18.9551 28.7397 18.9551C27.9267 18.9551 27.2762 19.6078 27.2762 20.4237C27.2762 21.2396 27.9267 21.8923 28.7397 21.8923Z"
                            fill="#4EAEE2"
                          />
                          <defs>
                            <linearGradient
                              id="paint0_linear_587_5536"
                              x1="10.7994"
                              y1="17.8667"
                              x2="26.7592"
                              y2="2.05666"
                              gradientUnits="userSpaceOnUse"
                            >
                              <stop stop-color="#64D3DD" />
                              <stop offset="1" stop-color="#3381E8" />
                            </linearGradient>
                          </defs>
                        </svg>
                      ),
                    },
                    {
                      title:
                        navData?.themeOption?.megaMenu?.topNav?.[1]?.tabs?.[2]
                          ?.tabLinksLeftColumn[2]?.linkText,
                      // "Cloud-Native Application Protection Platform (CNAPP)",
                      description:
                        navData?.themeOption?.megaMenu?.topNav?.[1]?.tabs?.[2]
                          ?.tabLinksLeftColumn[2]?.linkDescription,
                      link: navData?.themeOption?.megaMenu?.topNav?.[1]
                        ?.tabs?.[2]?.tabLinksLeftColumn[2]?.linkUrl,
                      icon: (
                        <svg
                          style={{ maxWidth: "25px", maxHeight: "25px" }}
                          className="no-hover"
                          width="31"
                          height="31"
                          viewBox="0 0 31 31"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M13.4383 5.65208C13.4491 5.66994 13.4598 5.68781 13.4669 5.70567L20.8263 23.3038C21.2835 24.3898 20.7691 25.6474 19.6759 26.1046C19.4044 26.219 19.1258 26.269 18.8471 26.269C18.0111 26.269 17.2109 25.776 16.8679 24.9543L11.4949 12.0933L6.12186 24.9543C5.7789 25.776 4.97866 26.269 4.14269 26.269C3.86404 26.269 3.58538 26.219 3.31387 26.1046C2.22069 25.6545 1.70625 24.397 2.16353 23.3038L9.53002 5.69853C9.54431 5.6628 9.56575 5.62708 9.58718 5.59135C9.59326 5.57918 9.59935 5.56687 9.60547 5.55448C9.6425 5.47954 9.68103 5.40157 9.73008 5.33413C9.76581 5.28412 9.80868 5.2341 9.85155 5.18409C9.89442 5.12693 9.94443 5.06262 9.99445 5.01261C10.0445 4.96259 10.1016 4.91972 10.1588 4.87685C10.1716 4.86584 10.1845 4.85436 10.1974 4.84277C10.235 4.80924 10.2735 4.77479 10.316 4.74824C10.4017 4.69108 10.4875 4.64821 10.5803 4.60534C10.5903 4.59934 10.5998 4.59334 10.609 4.5875C10.6326 4.57247 10.6546 4.55847 10.6804 4.54818C10.809 4.49102 10.9447 4.4553 11.0805 4.42672C11.1305 4.41243 11.1877 4.41243 11.2377 4.41243C11.2663 4.41004 11.2948 4.40687 11.3234 4.40369C11.3806 4.39734 11.4377 4.39099 11.4949 4.39099C11.5603 4.39099 11.6258 4.40298 11.6968 4.41598C11.7032 4.41717 11.7098 4.41837 11.7164 4.41957C11.7383 4.42201 11.7611 4.42361 11.7841 4.42524C11.8286 4.42838 11.8741 4.43159 11.9165 4.44101C12.0522 4.46959 12.188 4.50531 12.3166 4.56247C12.3523 4.57676 12.388 4.5982 12.4237 4.61963C12.5166 4.6625 12.6024 4.70537 12.681 4.75539C12.7234 4.78194 12.762 4.81638 12.7995 4.84992C12.8125 4.86151 12.8253 4.87299 12.8382 4.884C12.8953 4.92687 12.9525 4.96974 13.0025 5.01975C13.032 5.04926 13.059 5.08375 13.0865 5.11881C13.1056 5.14316 13.1249 5.1678 13.1454 5.19123L13.1454 5.19125C13.1883 5.24126 13.2311 5.29127 13.2669 5.34128C13.3159 5.40872 13.3544 5.48668 13.3915 5.56163C13.3976 5.57402 13.4037 5.58633 13.4098 5.5985C13.4169 5.61636 13.4276 5.63422 13.4383 5.65208ZM24.7129 6.62739C24.7129 5.44132 25.6703 4.48389 26.8564 4.48389C28.0425 4.48389 28.9999 5.44132 28.9999 6.62739V24.2255C28.9999 25.4116 28.0425 26.369 26.8564 26.369C25.6703 26.369 24.7129 25.4116 24.7129 24.2255V6.62739Z"
                            fill="url(#paint0_linear_2537_16626)"
                          />
                          <defs>
                            <linearGradient
                              id="paint0_linear_2537_16626"
                              x1="-1.0038"
                              y1="30.1966"
                              x2="33.4175"
                              y2="10.3043"
                              gradientUnits="userSpaceOnUse"
                            >
                              <stop stop-color="#1540F3" />
                              <stop offset="1" stop-color="#6ADDDB" />
                            </linearGradient>
                          </defs>
                        </svg>
                      ),
                    },
                  ],
                },
              ]}
            />
          </li>
          <li className="nav-list-items group flex flex-col lg:flex-row border-b lg:border-b-0 pt-[16px] pb-[16px]">
            <a
              href="/"
              className={`font-medium text-[14px] uppercase lg:normal-case lg:text-[16px] flex lg:items-center lg:relative ${textColor} pointer-events-none lg:pointer-events-auto px-[16px] lg:pt-0 lg:pb-[0px]`}
            >
              <span className="lg:group-hover:opacity-50 text-[#0738F1] lg:text-inherit nav-title">
                {navData?.themeOption?.megaMenu?.topNav?.[2].label}
              </span>
              <span
                className="absolute hidden lg:group-hover:block"
                style={{
                  bottom: "-10px",
                  left: "50%",
                  transform: "translateX(-50%)",
                  pointerEvents: "none",
                  zIndex: "20",
                }}
              >
                <svg
                  width="27"
                  height="12"
                  viewBox="0 0 27 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M11.566 1.63102L0 11.3848H27L15.434 1.63102C14.3168 0.688829 12.6832 0.688831 11.566 1.63102Z"
                    fill="white"
                  />
                  <path
                    opacity="0.5"
                    d="M11.566 1.63102L0 11.3848H27L15.434 1.63102C14.3168 0.688829 12.6832 0.688831 11.566 1.63102Z"
                    fill="white"
                  />
                </svg>
              </span>
            </a>
            <MegaMenuA
              primaryLink="solutions"
              primaryLinkData={{
                title:
                  navData?.themeOption?.megaMenu?.topNav?.[2]?.primaryLinkTitle,
                description:
                  navData?.themeOption?.megaMenu?.topNav?.[2]
                    ?.primaryLinkDescription,
                link: navData?.themeOption?.megaMenu?.topNav?.[2]?.url,
              }}
              data={[
                {
                  title:
                    navData?.themeOption?.megaMenu?.topNav?.[2]?.tabs?.[0]
                      ?.tabTitle,
                  links: [
                    {
                      title:
                        navData?.themeOption?.megaMenu?.topNav?.[2]?.tabs?.[0]
                          ?.tabLinksLeftColumn[0]?.linkText,
                      // "Cloud-Native Application Protection Platform (CNAPP)",
                      description:
                        navData?.themeOption?.megaMenu?.topNav?.[2]?.tabs?.[0]
                          ?.tabLinksLeftColumn[0]?.linkDescription,
                      link: navData?.themeOption?.megaMenu?.topNav?.[2]
                        ?.tabs?.[0]?.tabLinksLeftColumn[0]?.linkUrl,
                    },
                    {
                      title:
                        navData?.themeOption?.megaMenu?.topNav?.[2]?.tabs?.[0]
                          ?.tabLinksRightColumn[0]?.linkText,
                      // "Cloud-Native Application Protection Platform (CNAPP)",
                      description:
                        navData?.themeOption?.megaMenu?.topNav?.[2]?.tabs?.[0]
                          ?.tabLinksRightColumn[0]?.linkDescription,
                      link: navData?.themeOption?.megaMenu?.topNav?.[2]
                        ?.tabs?.[0]?.tabLinksRightColumn[0]?.linkUrl,
                    },
                    {
                      title:
                        navData?.themeOption?.megaMenu?.topNav?.[2]?.tabs?.[0]
                          ?.tabLinksLeftColumn[1]?.linkText,
                      // "Cloud-Native Application Protection Platform (CNAPP)",
                      description:
                        navData?.themeOption?.megaMenu?.topNav?.[2]?.tabs?.[0]
                          ?.tabLinksLeftColumn[1]?.linkDescription,
                      link: navData?.themeOption?.megaMenu?.topNav?.[2]
                        ?.tabs?.[0]?.tabLinksLeftColumn[1]?.linkUrl,
                    },
                    {
                      title:
                        navData?.themeOption?.megaMenu?.topNav?.[2]?.tabs?.[0]
                          ?.tabLinksRightColumn[1]?.linkText,
                      // "Cloud-Native Application Protection Platform (CNAPP)",
                      description:
                        navData?.themeOption?.megaMenu?.topNav?.[2]?.tabs?.[0]
                          ?.tabLinksRightColumn[1]?.linkDescription,
                      link: navData?.themeOption?.megaMenu?.topNav?.[2]
                        ?.tabs?.[0]?.tabLinksRightColumn[1]?.linkUrl,
                    },
                    {
                      title:
                        navData?.themeOption?.megaMenu?.topNav?.[2]?.tabs?.[0]
                          ?.tabLinksLeftColumn[2]?.linkText,
                      // "Cloud-Native Application Protection Platform (CNAPP)",
                      description:
                        navData?.themeOption?.megaMenu?.topNav?.[2]?.tabs?.[0]
                          ?.tabLinksLeftColumn[2]?.linkDescription,
                      link: navData?.themeOption?.megaMenu?.topNav?.[2]
                        ?.tabs?.[0]?.tabLinksLeftColumn[2]?.linkUrl,
                    },
                    {
                      title:
                        navData?.themeOption?.megaMenu?.topNav?.[2]?.tabs?.[0]
                          ?.tabLinksRightColumn[2]?.linkText,
                      // "Cloud-Native Application Protection Platform (CNAPP)",
                      description:
                        navData?.themeOption?.megaMenu?.topNav?.[2]?.tabs?.[0]
                          ?.tabLinksRightColumn[2]?.linkDescription,
                      link: navData?.themeOption?.megaMenu?.topNav?.[2]
                        ?.tabs?.[0]?.tabLinksRightColumn[2]?.linkUrl,
                    },
                    {
                      title:
                        navData?.themeOption?.megaMenu?.topNav?.[2]?.tabs?.[0]
                          ?.tabLinksLeftColumn[3]?.linkText,
                      // "Cloud-Native Application Protection Platform (CNAPP)",
                      description:
                        navData?.themeOption?.megaMenu?.topNav?.[2]?.tabs?.[0]
                          ?.tabLinksLeftColumn[3]?.linkDescription,
                      link: navData?.themeOption?.megaMenu?.topNav?.[2]
                        ?.tabs?.[0]?.tabLinksLeftColumn[3]?.linkUrl,
                    },
                  ],
                },
                {
                  title:
                    navData?.themeOption?.megaMenu?.topNav?.[2]?.tabs?.[1]
                      ?.tabTitle,
                  links: [
                    {
                      title:
                        navData?.themeOption?.megaMenu?.topNav?.[2]?.tabs?.[1]
                          ?.tabLinksLeftColumn[0]?.linkText,
                      // "Cloud-Native Application Protection Platform (CNAPP)",
                      description:
                        navData?.themeOption?.megaMenu?.topNav?.[2]?.tabs?.[1]
                          ?.tabLinksLeftColumn[0]?.linkDescription,
                      link: navData?.themeOption?.megaMenu?.topNav?.[2]
                        ?.tabs?.[1]?.tabLinksLeftColumn[0]?.linkUrl,
                    },
                    {
                      title:
                        navData?.themeOption?.megaMenu?.topNav?.[2]?.tabs?.[1]
                          ?.tabLinksRightColumn[0]?.linkText,
                      // "Cloud-Native Application Protection Platform (CNAPP)",
                      description:
                        navData?.themeOption?.megaMenu?.topNav?.[2]?.tabs?.[1]
                          ?.tabLinksRightColumn[0]?.linkDescription,
                      link: navData?.themeOption?.megaMenu?.topNav?.[2]
                        ?.tabs?.[1]?.tabLinksRightColumn[0]?.linkUrl,
                    },
                    {
                      title:
                        navData?.themeOption?.megaMenu?.topNav?.[2]?.tabs?.[1]
                          ?.tabLinksLeftColumn[1]?.linkText,
                      // "Cloud-Native Application Protection Platform (CNAPP)",
                      description:
                        navData?.themeOption?.megaMenu?.topNav?.[2]?.tabs?.[1]
                          ?.tabLinksLeftColumn[1]?.linkDescription,
                      link: navData?.themeOption?.megaMenu?.topNav?.[2]
                        ?.tabs?.[1]?.tabLinksLeftColumn[1]?.linkUrl,
                    },
                    {
                      title:
                        navData?.themeOption?.megaMenu?.topNav?.[2]?.tabs?.[1]
                          ?.tabLinksRightColumn[1]?.linkText,
                      // "Cloud-Native Application Protection Platform (CNAPP)",
                      description:
                        navData?.themeOption?.megaMenu?.topNav?.[2]?.tabs?.[1]
                          ?.tabLinksRightColumn[1]?.linkDescription,
                      link: navData?.themeOption?.megaMenu?.topNav?.[2]
                        ?.tabs?.[1]?.tabLinksRightColumn[1]?.linkUrl,
                    },
                    {
                      title:
                        navData?.themeOption?.megaMenu?.topNav?.[2]?.tabs?.[1]
                          ?.tabLinksLeftColumn[2]?.linkText,
                      // "Cloud-Native Application Protection Platform (CNAPP)",
                      description:
                        navData?.themeOption?.megaMenu?.topNav?.[2]?.tabs?.[1]
                          ?.tabLinksLeftColumn[2]?.linkDescription,
                      link: navData?.themeOption?.megaMenu?.topNav?.[2]
                        ?.tabs?.[1]?.tabLinksLeftColumn[2]?.linkUrl,
                    },
                  ],
                },
                {
                  title:
                    navData?.themeOption?.megaMenu?.topNav?.[2]?.tabs?.[2]
                      ?.tabTitle,
                  links: [
                    {
                      title:
                        navData?.themeOption?.megaMenu?.topNav?.[2]?.tabs?.[2]
                          ?.tabLinksLeftColumn[0]?.linkText,
                      // "Cloud-Native Application Protection Platform (CNAPP)",
                      description:
                        navData?.themeOption?.megaMenu?.topNav?.[2]?.tabs?.[2]
                          ?.tabLinksLeftColumn[0]?.linkDescription,
                      link: navData?.themeOption?.megaMenu?.topNav?.[2]
                        ?.tabs?.[2]?.tabLinksLeftColumn[0]?.linkUrl,
                    },
                    {
                      title:
                        navData?.themeOption?.megaMenu?.topNav?.[2]?.tabs?.[2]
                          ?.tabLinksRightColumn[0]?.linkText,
                      // "Cloud-Native Application Protection Platform (CNAPP)",
                      description:
                        navData?.themeOption?.megaMenu?.topNav?.[2]?.tabs?.[2]
                          ?.tabLinksRightColumn[0]?.linkDescription,
                      link: navData?.themeOption?.megaMenu?.topNav?.[2]
                        ?.tabs?.[2]?.tabLinksRightColumn[0]?.linkUrl,
                    },
                  ],
                },
              ]}
            />
          </li>
          <li className="nav-list-items group flex flex-col lg:flex-row border-b lg:border-b-0 pt-[16px] pb-[16px]">
            <a
              href="/"
              className={`font-medium text-[14px] uppercase lg:normal-case lg:text-[16px] flex lg:items-center lg:relative ${textColor} pointer-events-none lg:pointer-events-auto px-[16px] lg:pt-0 lg:pb-[0px]`}
            >
              <span className="lg:group-hover:opacity-50 text-[#0738F1] lg:text-inherit nav-title">
                {navData?.themeOption?.megaMenu?.topNav?.[3].label}
              </span>
              <span
                className="absolute hidden lg:group-hover:block"
                style={{
                  bottom: "-10px",
                  left: "50%",
                  transform: "translateX(-50%)",
                  pointerEvents: "none",
                  zIndex: "20",
                }}
              >
                <svg
                  width="27"
                  height="12"
                  viewBox="0 0 27 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M11.566 1.63102L0 11.3848H27L15.434 1.63102C14.3168 0.688829 12.6832 0.688831 11.566 1.63102Z"
                    fill="white"
                  />
                  <path
                    opacity="0.5"
                    d="M11.566 1.63102L0 11.3848H27L15.434 1.63102C14.3168 0.688829 12.6832 0.688831 11.566 1.63102Z"
                    fill="white"
                  />
                </svg>
              </span>
            </a>
            <MegaMenuB
              data={{
                primaryLink: {
                  title:
                    navData?.themeOption?.megaMenu?.topNav?.[3]
                      ?.primaryLinkTitle,
                  description:
                    navData?.themeOption?.megaMenu?.topNav?.[3]
                      ?.primaryLinkDescription,
                  link: navData?.themeOption?.megaMenu?.topNav?.[3]?.url,
                },
                secondaryLink: {
                  title: "Explore Success Stories",
                },
                col1: {
                  width: "50%",
                  colNum: 1,
                  title:
                    navData?.themeOption?.megaMenu?.topNav?.[3]
                      ?.megaMenuBox?.[0]?.title,
                  items:
                    navData?.themeOption?.megaMenu?.topNav?.[3]?.megaMenuBox?.[0]?.listLinks.map(
                      (item) => {
                        return {
                          title: item.label,
                          link: item.link,
                          targetBlank: item.newTab,
                        };
                      }
                    ),
                },
                col2: {
                  width: "50%",
                  colNum: 1,
                  title:
                    navData?.themeOption?.megaMenu?.topNav?.[3]
                      ?.megaMenuBox?.[1].title,
                  items:
                    navData?.themeOption?.megaMenu?.topNav?.[3]?.megaMenuBox?.[1]?.listLinks.map(
                      (item) => {
                        return {
                          title: item.label,
                          link: item.link,
                          targetBlank: item.newTab,
                        };
                      }
                    ),
                },
              }}
            />
          </li>
          <li className="nav-list-items group flex flex-col lg:flex-row border-b lg:border-b-0 pt-[16px] pb-[16px]">
            <a
              href="/"
              className={`font-medium text-[14px] uppercase lg:normal-case lg:text-[16px] flex lg:items-center lg:relative ${textColor} pointer-events-none lg:pointer-events-auto px-[16px] lg:pt-0 lg:pb-[0px]`}
            >
              <span className="lg:group-hover:opacity-50 text-[#0738F1] lg:text-inherit nav-title">
                {navData?.themeOption?.megaMenu?.topNav?.[4].label}
              </span>
              <span
                className="absolute hidden lg:group-hover:block"
                style={{
                  bottom: "-10px",
                  left: "50%",
                  transform: "translateX(-50%)",
                  pointerEvents: "none",
                  zIndex: "20",
                }}
              >
                <svg
                  width="27"
                  height="12"
                  viewBox="0 0 27 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M11.566 1.63102L0 11.3848H27L15.434 1.63102C14.3168 0.688829 12.6832 0.688831 11.566 1.63102Z"
                    fill="white"
                  />
                  <path
                    opacity="0.5"
                    d="M11.566 1.63102L0 11.3848H27L15.434 1.63102C14.3168 0.688829 12.6832 0.688831 11.566 1.63102Z"
                    fill="white"
                  />
                </svg>
              </span>
            </a>
            <MegaMenuB
              data={{
                primaryLink: {
                  title:
                    navData?.themeOption?.megaMenu?.topNav?.[4]
                      ?.primaryLinkTitle,
                  description:
                    navData?.themeOption?.megaMenu?.topNav?.[4]
                      ?.primaryLinkDescription,
                  link: navData?.themeOption?.megaMenu?.topNav?.[4]?.url,
                },
                secondaryLink: {
                  title: "Explore Resource Library",
                },
                col1: {
                  width: "65%",
                  colNum: 2,
                  title:
                    navData?.themeOption?.megaMenu?.topNav?.[4]
                      ?.megaMenuBox?.[0]?.title,
                  items:
                    navData?.themeOption?.megaMenu?.topNav?.[4]?.megaMenuBox?.[0]?.listLinks.map(
                      (item) => {
                        return {
                          title: item.label,
                          link: item.link,
                          targetBlank: item.newTab,
                        };
                      }
                    ),
                },
                col2: {
                  width: "35%",
                  colNum: 1,
                  title:
                    navData?.themeOption?.megaMenu?.topNav?.[4]
                      ?.megaMenuBox?.[1]?.title,
                  items:
                    navData?.themeOption?.megaMenu?.topNav?.[4]?.megaMenuBox?.[1]?.listLinks.map(
                      (item) => {
                        return {
                          title: item.label,
                          link: item.link,
                          targetBlank: item.newTab,
                        };
                      }
                    ),
                },
              }}
            />
          </li>
          <li className="nav-list-items group flex flex-col lg:flex-row border-b lg:border-b-0 pt-[16px] pb-[16px] lg:hidden">
            <MegaMenuB
              data={{
                col1: {
                  width: "100%",
                  colNum: 1,
                  title: "Company",
                  items:
                    navData?.themeOption?.megaMenu?.companyDropdownOptions?.map(
                      (item) => {
                        return {
                          title: item.pageName,
                          link: item.pageUrl,
                          targetBlank: item?.newTab,
                        };
                      }
                    ),
                },
              }}
            />
          </li>
          <li className="nav-list-link group flex flex-col lg:flex-row border-b lg:border-b-0 py-[1rem] lg:py-0 lg:hidden">
            <style>
              {`
              .padding-top-contact {
                padding-top: 0.5rem;
                padding-bottom: 0.5rem;
              }
              @media (min-width: 1024px) {
                .padding-top-contact {
                  padding-top: 0.5rem;
                  padding-bottom: 0.5rem;
                }
              }
            `}
            </style>
            <a
              href={navData?.themeOption?.megaMenu?.contactOptions?.contactUrl}
              className={`font-medium text-[18px] lg:normal-case lg:text-[16px] flex lg:items-center lg:relative ${textColor} px-[16px] padding-top-contact`}
            >
              <span
                className={`transition lg:group-hover:opacity-50 py-[1rem] ${textColor}`}
              >
                {navData?.themeOption?.megaMenu?.contactOptions?.contactLabel}
              </span>
            </a>
          </li>
          <li className="nav-list-link group flex flex-row lg:flex-row border-b lg:border-b-0 py-[1rem] lg:py-0 lg:hidden">
            <style>
              {`
              .padding-region {
                border-radius: 10px;
                margin-top: 0.5rem;
                margin-bottom: 0.5rem;
                padding-left: 12px;
                padding-right: 12px;
              }
              .padding-region:hover {
                background: #DBE2FF;
              }
              .padding-region span {
                color: #0738F1;
              }
            `}
            </style>
            <span
              className={`icon-language py-[1rem] flex items-center`}
              style={{
                marginRight: "16px",
                pointerEvents: "none",
                marginLeft: "16px",
              }}
            />
            <a
              href="/"
              className={`font-medium text-[18px] lg:normal-case lg:text-[16px] flex lg:items-center lg:relative ${textColor} padding-region`}
            >
              <span
                className={`transition lg:group-hover:opacity-50 py-[1rem] ${textColor}`}
              >
                EN
              </span>
            </a>
            <a
              href="/de"
              className={`font-medium text-[18px] lg:normal-case lg:text-[16px] flex lg:items-center lg:relative ${textColor} padding-region`}
            >
              <span
                className={`transition lg:group-hover:opacity-50 py-[1rem] ${textColor}`}
              >
                DE
              </span>
            </a>
            <a
              href="/fr"
              className={`font-medium text-[18px] lg:normal-case lg:text-[16px] flex lg:items-center lg:relative ${textColor} padding-region`}
            >
              <span
                className={`transition lg:group-hover:opacity-50 py-[1rem] ${textColor}`}
              >
                FR
              </span>
            </a>
          </li>
          <li className="nav-list-items ml-auto flex items-center group px-[16px] lg:px-0 gap-4">
            <a
              className="py-[2rem] text-center flex items-center justify-center w-[160px] h-[50px] text-white rounded-l-full rounded-r-full watch-demo nav-cta"
              href={navData?.themeOption?.megaMenu?.ctaUrl}
            >
              <span style={{ lineHeight: "16px", fontWeight: "600" }}>
                {navData?.themeOption?.megaMenu?.ctaText}
              </span>
            </a>
            <a
              className="py-[2rem] text-center flex items-center justify-center w-[160px] h-[50px] text-white rounded-l-full rounded-r-full login-btn lg:hidden"
              href="https://login.lacework.net/"
            >
              <span style={{ lineHeight: "16px", fontWeight: "600" }}>
                Login
              </span>
            </a>
          </li>
        </ul>
      </ul>
    </nav>
  );
};

export default function Home() {
  return (
    <>
      <Nav />
      <div className="bg-blue-500 h-[3000px] w-full z-[-1]"></div>
    </>
  );
}
